webpackJsonp([3],{

/***/ "+23j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue__ = __webpack_require__("oV5H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3897017c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_vue__ = __webpack_require__("yNSX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3897017c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0iwi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__explorer_card_vue__ = __webpack_require__("U2Li");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__explorer_ibutton_vue__ = __webpack_require__("r+yu");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Notifications',
  data: function data() {
    return {
      cards: [{
        content: {
          description: 'The company colours are: #7789ff and #33ff99'
        },
        objectID: '1'
      }, {
        content: {
          description: 'The company address is Explaain Ltd, Geovation Hub, 1 Sekforde Street, London EC1R 0BE'
        },
        objectID: '2'
      }]
    };
  },

  components: {
    card: __WEBPACK_IMPORTED_MODULE_0__explorer_card_vue__["a" /* default */],
    ibutton: __WEBPACK_IMPORTED_MODULE_1__explorer_ibutton_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "1AhV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-markdown',{class:{ editable: !(_vm.editable === false) },attrs:{"contenteditable":!(_vm.editable === false),"watches":['content'],"source":_vm.content,"linkify":false,"emoji":false},on:{"input":_vm.update}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1dcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"files"},[_c('header',{staticClass:"files-settings"},[_c('ibutton',{attrs:{"icon":"cloud","text":"Connect to Your Files","click":_vm.toggleConnect}}),_vm._v(" "),_c('ibutton',{attrs:{"icon":"refresh","text":"Refresh","click":_vm.getFiles}}),_vm._v(" "),(_vm.showingConnect)?_c('form',{staticClass:"new-user"},[_c('ibutton',{attrs:{"icon":"google","text":"Google Drive","click":_vm.connectSource}}),_vm._v(" "),_c('ibutton',{attrs:{"icon":"glass","text":"Confluence"}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"files"},[_c('h1',[_vm._v("Files Currently Processed as Cards:")]),_vm._v(" "),_c('table',{staticClass:"files"},_vm._l((_vm.files),function(file){return _c('tr',[_c('td',{staticClass:"icon"},[_c('icon',{attrs:{"name":"file-word-o"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(file.name))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4fNz":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ "64m6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__ = __webpack_require__("0iwi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eab8c20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__ = __webpack_require__("nvIt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eab8c20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "69NR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['show', 'type', 'duration', 'title'],
  components: {
    icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "6UJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* mixins */].reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    var self = this;
    this.renderChart(self.chartData, self.options);
  }
});

/***/ }),

/***/ "6Wec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_files_vue__ = __webpack_require__("QMze");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e7e384_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_files_vue__ = __webpack_require__("1dcn");
function injectStyle (ssrContext) {
  __webpack_require__("UEHQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_files_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e7e384_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_files_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6a8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loglevel__ = __webpack_require__("BvyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_loglevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__explorer_explorer_vue__ = __webpack_require__("IICg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__explorer_ibutton_vue__ = __webpack_require__("r+yu");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global chrome */

// import Vue from 'vue'





__WEBPACK_IMPORTED_MODULE_1_loglevel___default.a.setLevel('debug');

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['sidebar', 'local', 'testing'],
  data: function data() {
    return {
      organisation: {},
      auth: {
        user: {
          uid: '',
          auth: {},
          data: {}
        }
      },
      organisationID: '',
      orgLoading: false,
      errorMessage: '',
      signInButton: {
        text: 'Sign in with Google',
        disabled: true
      },
      firebaseConfig: {
        apiKey: 'AIzaSyBU0SEu3orHAoJ5eqxIJXS2VfyqXm1HoMU',
        authDomain: 'forgetmenot-1491065404838.firebaseapp.com',
        databaseURL: 'https://forgetmenot-1491065404838.firebaseio.com',
        projectId: 'forgetmenot-1491065404838',
        storageBucket: '',
        messagingSenderId: '400087312665'
      },
      algoliaParams: { // Need to fetch these from app.vue to avoid duplication!
        appID: 'D3AE3TSULH'
      },
      authorParams: {
        // url: 'https://forget-me-not--app.herokuapp.com/api/memories',
        url: 'https://forget-me-not--staging.herokuapp.com/api/memories',
        // url: '//localhost:3000/api/memories',
        importUrl: 'https://forget-me-not--staging.herokuapp.com/api/import'
      },
      plugin: true,
      logo: '../images/logo.png',
      pageCards: [], // ???
      cards: [] // ???
      // sidebar: true
    };
  },

  components: {
    Explorer: __WEBPACK_IMPORTED_MODULE_4__explorer_explorer_vue__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon_vue__["a" /* default */],
    ibutton: __WEBPACK_IMPORTED_MODULE_5__explorer_ibutton_vue__["a" /* default */]
  },
  created: function created(a) {
    var self = this;
    // self.getUser()
    if (self.testing) {
      self.organisation = {
        id: 'explaain'
      };
      self.auth = {
        user: {
          auth: {},
          data: {
            algoliaKey: '88bd0a77faff65d4ace510fbf172a4e1',
            name: {
              first: 'Jeremy',
              last: 'Evans'
            },
            teams: []
          }
        },
        uid: 'vZweCaZEWlZPx0gpQn2b1B7DFAZ2'
      };
    } else if (self.plugin) {
      this.refreshUser().then(function (res) {
        console.log('self.organisation:', self.organisation);
      });
      // self.fromPage()
    }

    // Vue.use(Auth, {
    //   organisation: self.organisation,
    //   // getUserDataUrl: '//forget-me-not--staging.herokuapp.com/api/user',
    //   getUserDataUrl: '//localhost:3000/api/user',
    // })
    // Auth.initApp(false, self.onAuthStateChanged)

    window.addEventListener('message', function (event) {
      // log.info(event.data.action)
      switch (event.data.action) {
        case 'setLoading':
          self.$emit('setLoading');
          break;
        case 'updatePageResults':
          __WEBPACK_IMPORTED_MODULE_1_loglevel___default.a.info(event.data);
          self.pageCards = event.data.data.pageResults;
          __WEBPACK_IMPORTED_MODULE_1_loglevel___default.a.info(self.pageCards);
          self.updateCards(self.pageCards, 'No cards found from page');
          break;
        case 'closingDrawer':
          __WEBPACK_IMPORTED_MODULE_1_loglevel___default.a.info('[frame] Closing Drawer!');
          window.scrollTo(0, 0);
          self.$emit('closingDrawer');
          break;
      }
    }, false);
    self.refreshUser();
  },
  methods: {
    selectOrganisation: function selectOrganisation() {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        self.orgLoading = true;
        chrome.runtime.sendMessage({ action: 'selectOrganisation', data: { organisationID: self.organisationID } }, function (response) {
          console.log('response', response);
          self.orgLoading = false;
          if (response.error) {
            self.errorMessage = 'Sorry, we can\'t sign you in to that organisation!';
            reject(response.error);
          } else {
            self.organisation = response.organisation;
            self.algoliaParams.apiKey = response.data.algoliaKey;
            self.algoliaParams.organisationID = response.organisation.id;
            self.auth.user = response; // Includes organisation
            resolve(response);
          }
        });
      });
    },
    refreshUser: function refreshUser() {
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        chrome.runtime.sendMessage({ action: 'getUser' }, function (response) {
          console.log('response user', response);
          self.auth.user = response;
          if (response.organisation) self.organisation = response.organisation;
          resolve(response);
        });
      });
    },
    // toggleSignIn: function() {
    //   const self = this
    //   if (this.sidebar) {
    //     console.log('sidebar')
    //   } else {
    //     console.log('not sidebar')
    //     chrome.runtime.sendMessage({action: 'signIn'}, response => {
    //       console.log('response user', response)
    //       self.auth.user = response
    //     })
    //   }
    //   // Auth.toggleSignIn()
    //   this.signInButton.disabled = true
    // },
    // onAuthStateChanged: function(user) {
    //   console.log('onAuthStateChanged')
    //   console.log(user)
    //   this.auth.user = user
    //   this.auth.authState = Auth.authState
    // },
    // onAuthStateChanged: function(user) {
    //   console.log('user', user)
    //   this.user = user
    //   this.signInButton.text = user ? 'Sign out' : 'Sign in with Google'
    //   this.signInButton.disabled = false
    // },
    // getUser: function() {
    //   const self = this
    //   try {
    //     chrome.runtime.sendMessage({action: 'getUser'}, function(userID) {
    //       self.userID = userID || self.userID
    //       console.log('userID', self.userID)
    //     })
    //   } catch (e) {
    //     this.plugin = false
    //     self.userID = '1627888800569309'
    //     console.log('userID', self.userID)
    //   }
    // },
    fromPage: function fromPage() {
      console.log('fromPage');
      var message = { action: 'getPageResults' };
      window.parent.postMessage(message, '*');
      this.$emit('setLoading');
    },
    updateCards: function updateCards(cards, noCardMessage) {
      console.log(cards);
      var data = {
        cards: cards,
        noCardMessage: noCardMessage
      };
      __WEBPACK_IMPORTED_MODULE_1_loglevel___default.a.debug(data);
      this.$emit('updateCards', data);
    },
    closeDrawer: function closeDrawer() {
      console.log('closeDrawer');
      var message = { action: 'closeDrawer' };
      window.parent.postMessage(message, '*');
    }
  }
});

/***/ }),

/***/ "8CGj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8LWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cardlet_vue__ = __webpack_require__("t8wU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_explaain_search_js__ = __webpack_require__("Huz3");
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['allCards', 'setCard', 'auth'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      query: '',
      resultList: [],
      loading: false
    };
  },
  computed: {
    results: function results() {
      var self = this;
      return self.resultList.map(function (objectID) {
        return self.allCards[objectID];
      });
    }
  },
  components: {
    cardlet: __WEBPACK_IMPORTED_MODULE_2__cardlet_vue__["a" /* default */]
  },
  methods: {
    clearResults: function clearResults() {
      this.resultList = [];
    },
    selectResult: function selectResult(card) {
      this.clearResults();
      this.$emit('select', card);
    },
    search: function search() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__plugins_explaain_search_js__["a" /* default */].searchCards(self.auth.user, self.query, 6).then(function (hits) {
        self.loading = false;
        self.resultList = hits.map(function (card) {
          return card.objectID;
        });
        hits.forEach(function (hit) {
          self.setCard(hit.objectID, hit);
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    searchTempLocal: function searchTempLocal() {
      var self = this;
      var hits = [{ 'intent': 'storeMemory', 'sender': '1627888800569309', 'listItems': ['620064670', '620064680', '620064690', '620064700'], 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508426117869, 'objectID': '619948630', 'description': 'Inject Meeting Notes' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508426117257, 'objectID': '620064700', 'description': 'Keep all signed timesheets and receipts' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508426117225, 'objectID': '620064690', 'description': 'Business model => pro version only' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508426117152, 'objectID': '620064680', 'description': 'Languages' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508426116967, 'objectID': '620064670', 'description': 'Finish card creation & editing' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateCreated': 1508425700874, 'dateUpdated': 1508425700874, 'objectID': '651610261', 'description': 'Asdf' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'listItems': ['645331361', '610938240', '610473050'], 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508421510702, 'objectID': '639442471', 'description': 'Here is a list' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508421509549, 'objectID': '610938240', 'description': 'This is a brand new list' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508421508835, 'objectID': '645331361', 'description': 'A serious item' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508421508588, 'objectID': '610473050', 'description': 'Another list item' }];
      // self.cards = hits
      self.resultList = hits.map(function (card) {
        return card.objectID;
      });
      hits.forEach(function (hit) {
        self.setCard(hit.objectID, hit);
      });
    }
  }
});

/***/ }),

/***/ "9nIT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* mixins */].reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    var self = this;
    console.log('hello');
    this.renderChart(self.chartData, self.options);
  }
});

/***/ }),

/***/ "BEaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


!function () {
  "use strict";
  function e(e, t, o) {
    var s;if ("undefined" != typeof XMLHttpRequest) s = new XMLHttpRequest();else for (var n = ["MSXML2.XmlHttp.5.0", "MSXML2.XmlHttp.4.0", "MSXML2.XmlHttp.3.0", "MSXML2.XmlHttp.2.0", "Microsoft.XmlHttp"], i = 0, r = n.length; r > i; i++) {
      try {
        s = new ActiveXObject(n[i]);break;
      } catch (l) {}
    }s.onreadystatechange = function () {
      4 === s.readyState && o(s);
    }, s.open("GET", e, !0), t && s.setRequestHeader && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(t).forEach(function (e, o) {
      s.setRequestHeader(e, t[e]);
    }), s.send("");
  }var t = !1;void 0 === window.Kloudless && (window.Kloudless = {}), window.Kloudless.baseUrl = "https://api.kloudless.com", window.Kloudless.apiVersion = "v1", window.Kloudless._authenticators = {}, window.Kloudless._authenticators_by_element = {}, window.Kloudless._authenticator_iframe = void 0, window.Kloudless._popup = void 0;var o = navigator.userAgent.toLowerCase(),
      s = !1,
      n = -1;-1 !== o.indexOf("msie") ? (s = !0, n = parseInt(o.split("msie")[1])) : -1 !== o.indexOf("trident/") && (s = !0, n = parseInt(o.split("rv:")[1])), window.addEventListener("message", function (e) {
    var o = "kloudless:";if (t && console.log("[DEBUG] Message received", e), e.origin !== window.Kloudless.baseUrl) return void console.log("[ERROR] Origin mismatch:", e);if (0 !== e.data.indexOf(o)) return void console.log("[ERROR] Namespace mismsatch:", e);var n = JSON.parse(e.data.substring(o.length));return "authentication" != n.type ? void console.log("[ERROR] Incorrect content type:", e) : (setTimeout(function () {
      var e = window.Kloudless._authenticators[n.id];e ? e.callback(n.data) : console.log("[ERROR] No Authenticator found for ID:", n.id);
    }, 0), s ? e.source.postMessage("kloudless:" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ type: "close" }), e.origin) : window.Kloudless._popup && (window.Kloudless._popup.close(), window.Kloudless._popup = void 0), void (t && console.log("[DEBUG] Confirmation sent", e.origin)));
  }, !1);var i = function i(e) {
    var t = "/services/";return "string" == typeof e.services && (e.services = [e.services]), void 0 === e.services ? t += "?" : 1 == e.services.length ? t += e.services[0] + "?" : e.services.length > 1 && (t += "?services=" + e.services.map(function (e) {
      return e.trim();
    }).join(",") + "&"), t += "app_id=" + e.app_id + "&admin=" + (e.admin ? 1 : "") + "&extra=" + (e.extra ? e.extra : "") + "&callback=&retrieve_account_key=", e.group && (t += "&group=" + e.group), e.edit_account && (t += "&edit_account=" + e.edit_account), e.developer && (t += "&developer=true"), t;
  },
      r = function r(e) {
    var t = "/" + window.Kloudless.apiVersion + "/oauth/?";return e.redirect_uri = "urn:ietf:wg:oauth:2.0:oob", e.response_type = "token", e.state = parseInt(Math.random() * Math.pow(10, 10)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(e).forEach(function (o, s) {
      var n = e[o];"scopes" == o && n.join && (n = n.join(" ")), t += "&" + o + "=" + n;
    }), t;
  },
      l = function l() {
    if (void 0 === window.Kloudless._authenticator_iframe) {
      var e = document.createElement("iframe");e.setAttribute("id", "kloudless_iexd"), e.setAttribute("src", window.Kloudless.baseUrl + "/static/iexd.html"), e.style.display = "none", document.getElementsByTagName("body")[0].appendChild(e), window.Kloudless._authenticator_iframe = e;
    }
  },
      a = function a(e) {
    return function (t) {
      e(null, t);
    };
  },
      d = function d(t, o) {
    return function (s) {
      if (!s.state || s.state.toString() !== o.toString()) return t({ error: "invalid_state" });if (!s.access_token) return t(s);var n = { Authorization: "Bearer " + s.access_token };e(window.Kloudless.baseUrl + "/" + window.Kloudless.apiVersion + "/oauth/token/", n, function (o) {
        200 !== o.status && t(s);var i = JSON.parse(o.responseText).account_id;e(window.Kloudless.baseUrl + "/" + window.Kloudless.apiVersion + "/accounts/" + i + "/?retrieve_full=False", n, function (e) {
          200 === e.status && (s.account = JSON.parse(e.responseText)), t(s);
        });
      });
    };
  };window.Kloudless.authenticator = function (e, o, n) {
    if (l(), void 0 !== window.jQuery && e instanceof window.jQuery && (e = e.get(0)), e && !(e instanceof Element)) {
      if (n) throw new Error("'element' must be an Element or jQuery object.");n = o, o = e, e = null;
    }if (!o.client_id && !o.app_id) throw new Error("An App ID is required.");var u;o.app_id ? (u = i(o), n = a(n)) : (u = r(o), n = d(n, o.state));var c = parseInt(Math.random() * Math.pow(10, 10)),
        w = window.location.protocol + "//" + window.location.host;u += "&request_id=" + c, u += "&origin=" + encodeURIComponent(w), t && console.log("[DEBUG]", "Path is", window.Kloudless.baseUrl + u);var p = function p() {
      var e = 600,
          t = 1e3,
          o = (screen.height - e) / 2 - 50,
          n = (screen.width - t) / 2,
          i = "resizable,scrollbars,status,height=" + e + ",width=" + t + ",top=" + o + ",left=" + n;if (s) {
        var r = { type: "prepareToOpenAuthenticator", url: window.Kloudless.baseUrl + u, params: i },
            l = window.Kloudless._authenticator_iframe;l.contentWindow.postMessage("kloudless:" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(r), l.src), l.style.position = "fixed", l.style.display = "block", l.style.height = "100%", l.style.width = "100%", l.style.top = "0", l.style.bottom = "0", l.style.left = "0", l.style.right = "0";var a = 1,
            d = setInterval(function () {
          .75 >= a && (clearInterval(d), l.style.display = "none"), l.style.opacity = a, l.style.filter = "alpha(opacity=" + 100 * a + ")", a -= .01 * a;
        }, 120);
      } else window.Kloudless._popup = window.open(window.Kloudless.baseUrl + u, "kPOPUP", i), window.Kloudless._popup.focus();
    };return e && void 0 !== window.Kloudless._authenticators_by_element[e.outerHTML] && window.Kloudless.stop(e), window.Kloudless._authenticators[c] = { clickHandler: p, callback: n }, e && (window.Kloudless._authenticators_by_element[e.outerHTML] = c, e.addEventListener("click", p)), { launch: p };
  }, window.Kloudless.stop = function (e) {
    void 0 !== window.jQuery && e instanceof window.jQuery && (e = e.get(0));var t = window.Kloudless._authenticators_by_element[e.outerHTML];if (t) {
      var o = window.Kloudless._authenticators[t];e.removeEventListener("click", o.clickHandler), delete window.Kloudless._authenticators[t], delete window.Kloudless._authenticators_by_element[e.outerHTML];
    } else console.log("No click listener found to remove.");
  };
}();
!function () {
  "use strict";
  if (window.Event.prototype.preventDefault || (window.Event.prototype.preventDefault = function () {
    this.returnValue = !1;
  }), !Element.prototype.addEventListener) {
    var e = [],
        t = function t(_t, n) {
      var o = this,
          r = function r(e) {
        e.target = e.srcElement, e.currentTarget = o, n.handleEvent ? n.handleEvent(e) : n.call(o, e);
      };this.attachEvent("on" + _t, r), e.push({ object: this, type: _t, listener: n, wrapper: r });
    },
        n = function n(t, _n) {
      for (var o = 0; o < e.length;) {
        var r = e[o];if (r.object == this && r.type == t && r.listener == _n) {
          this.detachEvent("on" + t, r.wrapper);break;
        }++o;
      }
    };Element.prototype.addEventListener = t, Element.prototype.removeEventListener = n, window.HTMLDocument && (window.HTMLDocument.prototype.addEventListener = t, window.HTMLDocument.prototype.removeEventListener = n), window.Window && (window.Window.prototype.addEventListener = t, window.Window.prototype.removeEventListener = n);
  }
}();

/***/ }),

/***/ "CEdw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CGSI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5d0258de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("FMyu");
function injectStyle (ssrContext) {
  __webpack_require__("wTBZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5d0258de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ea6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FDVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('h1',[_vm._v("Profile Settings")]),_vm._v(" "),_c('div',[_c('b',[_vm._v("First Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.data.name.first),expression:"user.data.name.first"}],domProps:{"value":(_vm.user.data.name.first)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.data.name, "first", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Last Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.data.name.last),expression:"user.data.name.last"}],domProps:{"value":(_vm.user.data.name.last)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.data.name, "last", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('b',[_vm._v("Email Address:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.data.email),expression:"user.data.email"}],domProps:{"value":(_vm.user.data.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.data, "email", $event.target.value)}}})]),_vm._v(" "),_c('button',{attrs:{"type":"button","name":"button"}},[_vm._v("Save Changes")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FGQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "FMyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Huz3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loglevel__ = __webpack_require__("BvyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_loglevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_q__ = __webpack_require__("/Luh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_algoliasearch__ = __webpack_require__("6gPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_algoliasearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_algoliasearch__);










__WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.setLevel('debug');

var Search = {
  install: function install(Vue, algoliaParams, userAuth) {

    /**
    * Gets a card, generating and saving it if necessary
    *
    * @param  {Object} data - Should have one of [objectID, sameAs, query]
    * @param  {String} [data.objectID]
    * @param  {Array} [data.sameAs]
    * @param  {String} [data.query]
    * @param  {String} [data.refresh] - Forces refresh if present and true
    * @return {Object} card
    */
    var yieldCard = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(data) {
        var card, retrievedCard, savedCard;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('yieldCard', data);

                if (!(!data.objectID && (!data.sameAs || !data.sameAs[0]) && data.query)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return generateFromQuery(data.query);

              case 4:
                card = _context.sent;

                data.sameAs = card.sameAs;

              case 6:
                if (!data.objectID) {
                  _context.next = 12;
                  break;
                }

                _context.next = 9;
                return getCard(data.objectID);

              case 9:
                retrievedCard = _context.sent;
                _context.next = 16;
                break;

              case 12:
                if (!(data.sameAs && data.sameAs[0])) {
                  _context.next = 16;
                  break;
                }

                _context.next = 15;
                return getFromSameAs(data.sameAs);

              case 15:
                retrievedCard = _context.sent;

              case 16:
                if (!(!retrievedCard || data.refresh)) {
                  _context.next = 28;
                  break;
                }

                if (card) {
                  _context.next = 21;
                  break;
                }

                _context.next = 20;
                return generateFromSameAs(data.sameAs);

              case 20:
                card = _context.sent;

              case 21:
                if (retrievedCard) card.objectID = retrievedCard.objectID;
                _context.next = 24;
                return saveCard(card);

              case 24:
                savedCard = _context.sent;

                if (!card.objectID) card.objectID = savedCard.objectID;
                _context.next = 29;
                break;

              case 28:
                // Otherwise, set card to retrieved data
                card = correctChunkCard(retrievedCard);

              case 29:

                // Return card
                console.log('Returning card:', card);
                return _context.abrupt('return', card);

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function yieldCard(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    __WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.debug('algoliaParams', algoliaParams);
    __WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.debug('userAuth', userAuth);
    var AlgoliaClient = __WEBPACK_IMPORTED_MODULE_8_algoliasearch___default()(algoliaParams.appID, userAuth.data.algoliaKey, {
      protocol: 'https:'
    });
    var AlgoliaIndex = AlgoliaClient.initIndex(algoliaParams.index);
    var AlgoliaChunkIndex = AlgoliaClient.initIndex(userAuth.organisation.id + '__Cards');
    var AlgoliaFileIndex;
    if (!algoliaParams.noFiles) AlgoliaFileIndex = AlgoliaClient.initIndex(userAuth.organisation.id + '__Files');

    // Need to sort this out - only for Explaain currently and probably shouldn't be here!
    var saveCard = function saveCard(card) {
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('saveCard', card);
        var cardToSave = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(card));
        var keys = ['description', 'title', 'listCards'];
        keys.forEach(function (key) {
          if (cardToSave.content[key]) cardToSave[key] = cardToSave.content[key];
        });
        delete cardToSave.content;
        AlgoliaChunkIndex.addObject(cardToSave, function (err, content) {
          if (err) {
            console.log('Error - Card Not Saved!', err);
            reject(err);
          } else {
            console.log('Card Saved:', content);
            resolve(content);
          }
        });
      });
    };

    var generateFromQuery = function generateFromQuery(query) {
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('generateFromQuery', query);
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('//lookup.dbpedia.org/api/search.asmx/KeywordSearch?QueryString=' + encodeURIComponent(query)).then(function (res) {
          console.log(res);
          var card = dbpediaQueryToCards(res.data.results[0]);
          console.log('Generated from Query: ', card);
          resolve(card);
        }).catch(function (err) {
          console.log(err);
          reject(err);
        });
      });
    };

    var generateFromSameAs = function generateFromSameAs(sameAs) {
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('generateFromSameAs', sameAs);
        var data = [];
        sameAs.forEach(function (uri) {
          var type = getSameAsType(uri);
          switch (type) {
            case 'dbpedia':
              data.push({
                type: 'dbpedia',
                uri: getDbpediaFetchURI(uri)
              });
              break;
          }
        });
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(data.map(function (source) {
          return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(source.uri);
        })).then(function (res) {
          console.log(res);
          var cardsToCombine = res.map(function (sourceResults, i) {
            console.log(sourceResults, i);
            return sourceDataToCard(data[i].type, sourceResults);
          });
          var card = combineLinkedData(cardsToCombine); // Should be better than just taking the first one!
          console.log('Generated from Query: ', card);
          resolve(card);
        }).catch(function (err) {
          console.log(err);
          reject(err);
        });
      });
    };

    var getFromSameAs = function getFromSameAs(sameAs) {
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('getFromSameAs', sameAs);
        var filters = 'sameAs: "' + sameAs.join('" OR sameAs: "') + '"';
        searchCards(userAuth, '', null, false, { filters: filters }).then(function (hits) {
          if (hits && hits.length) {
            console.log('Found from sameAs:', hits[0]);
            resolve(hits[0]);
          } else {
            console.log('Not found from sameAs.');
            resolve(null);
          }
        });
      });
    };

    var getSameAsType = function getSameAsType(uri) {
      if (uri.indexOf('dbpedia') > -1) {
        // Not very safe!
        return 'dbpedia';
      } else {
        return null;
      }
    };

    var sourceDataToCard = function sourceDataToCard(type, sourceData) {
      console.log('sourceDataToCard', type, sourceData);
      var card;
      switch (type) {
        case 'dbpedia':
          card = dbpediaToCards(sourceData);
      }
      return card;
    };

    var combineLinkedData = function combineLinkedData(data) {
      return data[0]; // @TODO
    };

    var getDbpediaFetchURI = function getDbpediaFetchURI(uri) {
      return uri.replace('//dbpedia.org/resource/', '//dbpedia.org/data/') + '.json';
    };

    var tailorDescription = function tailorDescription(description) {
      var maxChars = 300;
      description = description.replace(/ *\([^)]*\) */g, ' ').replace(/ \./g, '.');
      var sentences = description.split(/\. (?=[A-Z])/).map(function (s) {
        return s + '.';
      });
      while (sentences.join(' ').length > maxChars) {
        sentences.pop();
      }
      description = sentences.join(' ');
      return description;
    };

    var dbpediaQueryToCards = function dbpediaQueryToCards(data) {
      console.log('dbpediaQueryToCards', data);
      console.log(data.description);
      console.log(data.description.replace(/ *\([^)]*\) */g, ' '));
      return {
        content: {
          title: data.label,
          description: tailorDescription(data.description)
        },
        sameAs: [data.uri],
        sources: [{
          type: 'source',
          name: 'Wikipedia',
          url: (data.url || data.uri).replace('//dbpedia.org/resource/', '//en.wikipedia.org/wiki/')
        }]
      };
    };

    var dbpediaToCards = function dbpediaToCards(data) {
      console.log('dbpediaToCards', data);
      var resource = data.request.responseURL.replace('//dbpedia.org/data', '//dbpedia.org/resource').replace('.json', '');
      console.log('resource', resource);
      var title = data.data[resource]['http://www.w3.org/2000/01/rdf-schema#label'].filter(function (lang) {
        return lang.lang === 'en';
      })[0].value;
      console.log('title', title);
      var description = tailorDescription(data.data[resource]['http://www.w3.org/2000/01/rdf-schema#comment'].filter(function (lang) {
        return lang.lang === 'en';
      })[0].value);
      console.log('description', description);
      var wiki = data.data[resource]['http://xmlns.com/foaf/0.1/isPrimaryTopicOf'][0].value;
      console.log('wiki', wiki);
      return {
        content: {
          title: title,
          description: description
        },
        sameAs: [resource],
        sources: [{
          type: 'source',
          name: 'Wikipedia',
          url: wiki
        }]
      };
    };

    var advancedSearch = function advancedSearch(params) {
      var d = __WEBPACK_IMPORTED_MODULE_6_q___default.a.defer();
      AlgoliaIndex.clearCache();
      AlgoliaIndex.search(params, function (e, content) {
        if (e) {
          __WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.trace(e);
          d.reject(e);
        } else {
          var cards = content.hits.map(function (card) {
            return correctCard(card);
          });
          AlgoliaFileIndex.search();
          fetchListItemCards(cards).then(function (results) {
            console.log('results', results);
            var allHits;
            try {
              allHits = cards.concat(results);
            } catch (e) {
              console.log(e);
            }
            console.log('allHits', allHits);
            d.resolve(allHits);
          });
        }
      });
      return d.promise;
    };

    var advancedChunkSearch = function advancedChunkSearch(params, showHighlights) {
      var d = __WEBPACK_IMPORTED_MODULE_6_q___default.a.defer();
      var cards = [];
      if (params.filters.indexOf('teams: ') > -1) delete params.filters; // Removing teams as a filter for now
      if (params.hitsPerPage === null) delete params.hitsPerPage;
      AlgoliaChunkIndex.clearCache();
      console.log(params);
      AlgoliaChunkIndex.search(params, function (e, content) {
        if (e) {
          __WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.trace(e);
          d.reject(e);
        } else {
          console.log(111);
          console.log(content.hits);
          cards = content.hits.map(function (card) {
            return correctChunkCard(card, showHighlights);
          });
          console.log(cards);
          var fileIDs = [];
          cards.forEach(function (card) {
            if (card.fileID && fileIDs.indexOf(card.fileID) === -1) fileIDs.push(card.fileID);
          });
          console.log(fileIDs);
          var filePromise = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            if (fileIDs.length) {
              AlgoliaFileIndex.getObjects(fileIDs, function (err, content) {
                if (err) reject(err);else {
                  resolve(content);
                }
              });
            } else {
              resolve();
            }
          });
          console.log(111);
          filePromise.then(function (files) {
            if (files) {
              console.log('files', files);
              cards.map(function (card) {
                card.files = files.results.filter(function (file) {
                  return file.objectID === card.fileID;
                });
                card.files.forEach(function (file) {
                  file.title = card._highlightResult.fileTitle && showHighlights ? card._highlightResult.fileTitle.value : file.title;
                });
                return card;
              });
            }
            console.log(222);
            cards = combineDuplicateContents(cards);
            console.log('cards', cards);
            d.resolve(cards);
          }).catch(function (err) {
            d.reject(err);
          });
        }
      });
      return d.promise;
    };

    var chunkGet = function chunkGet(objectID, showHighlights) {
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        AlgoliaChunkIndex.getObject(objectID, function (e, content) {
          if (e) {
            __WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.trace(e);
            reject(e);
          } else {
            var card = correctChunkCard(content, showHighlights);
            var filePromise = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              if (card.fileID) {
                AlgoliaFileIndex.getObject(card.fileID, function (err, content) {
                  if (err) reject(err);else resolve(content);
                });
              } else {
                resolve();
              }
            });
            filePromise.then(function (file) {
              if (file) card.file = file;
              resolve(card);
            }).catch(function (err) {
              reject(err);
            });
          }
        });
      });
    };

    var searchCards = function searchCards(user, searchText, hitsPerPage, showHighlights, extraParams) {
      var d = __WEBPACK_IMPORTED_MODULE_6_q___default.a.defer();
      var params = {
        query: searchText,
        filters: 'teams: "' + user.data.teams.map(function (team) {
          return team.team;
        }).join('" OR teams: "') + '"',
        hitsPerPage: hitsPerPage || null
      };
      if (extraParams) params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(params, extraParams);
      advancedChunkSearch(params, showHighlights).then(function (hits) {
        __WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.trace(hits);
        d.resolve(hits);
      }).catch(function (e) {
        d.reject(e);
      });
      return d.promise;
    };

    var fetchListItemCards = function fetchListItemCards(cards) {
      var d = __WEBPACK_IMPORTED_MODULE_6_q___default.a.defer();
      var promises = [];
      cards.forEach(function (card) {
        card.content.listCards = [];
        if (!card.content.listItems) card.content.listItems = [];
        card.content.listItems.forEach(function (key) {
          // const p = Q.defer()
          promises.push(getCard(key)); // Do we need to notify the card or provide callbacks etc here?
          // promises.push(p.promise)
        });
      });
      __WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.trace(promises);
      __WEBPACK_IMPORTED_MODULE_6_q___default.a.allSettled(promises).then(function (results) {
        console.log('fetchListItemCards results', results);
        var cards = results.map(function (result) {
          return result.value;
        });
        cards.forEach(function (card) {
          card.fetched = true;
        });
        d.resolve(cards);
      }).catch(function (e) {
        __WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.trace(e);
        d.reject(e);
      });
      return d.promise;
    };

    var getCard = function getCard(objectID) {
      return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('getCard', objectID);
        AlgoliaIndex.getObject(objectID, function (e, content) {
          if (e) {
            __WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.trace(e);
            reject(e);
          } else {
            var card = correctCard(content);
            console.log('gotCard:', card);
            resolve(card);
          }
        });
      });
    };

    var correctCard = function correctCard(card) {
      if (!card.content || !card.content.description) card.content = {
        title: card.title || '',
        description: card.description || card.sentence || card.text || card.content,
        listItems: card.listItems || []
      };
      if (card.sentence) delete card.sentence;
      if (card.text) delete card.text;
      if (card.description) delete card.description;
      return card;
    };

    var correctChunkCard = function correctChunkCard(card, showHighlights) {
      card.content = {
        title: showHighlights && card._highlightResult && card._highlightResult.title ? card._highlightResult.title.value : card.title || '',
        description: (showHighlights && card._highlightResult && card._highlightResult.description ? card._highlightResult.description.value : card.description) || (showHighlights && card._highlightResult && card._highlightResult.content ? card._highlightResult.content.value : card.content) || ''
      };
      return card;
    };

    var combineDuplicateContents = function combineDuplicateContents(cards) {
      cards.forEach(function (card2, j) {
        cards.slice(0, j).forEach(function (card1, i) {
          if (card1 && card1.content.description === card2.content.description) {
            if (card1.files.objectID !== card2.files.objectID) card1.files = card1.files.concat(card2.files);
            cards[j] = null;
          }
        });
      });
      cards = cards.filter(function (card) {
        return card !== null;
      });
      return cards;
    };

    var compoundSearch = function compoundSearch(user, searchText) {
      var d = __WEBPACK_IMPORTED_MODULE_6_q___default.a.defer();
      var maxLength = 400;
      var searchTextArray = [];
      var hitsPerPage = Math.min(Math.max(Math.ceil(10 / (searchText.length / maxLength)), 3), 12);
      for (var i = 0; i < searchText.length; i += maxLength) {
        searchTextArray.push(searchText.substring(i, i + maxLength));
      }var promises = searchTextArray.map(function (t, j) {
        return searchCards(user, t, hitsPerPage);
      });
      __WEBPACK_IMPORTED_MODULE_6_q___default.a.allSettled(promises).then(function (res) {
        var results = [].concat.apply([], res.map(function (r) {
          return r.value;
        }));
        results = removeDuplicates(results, 'objectID');
        __WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.trace(results);
        d.resolve(results);
      }).catch(function (e) {
        __WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.trace(e);
      });
      return d.promise;
    };

    var removeDuplicates = function removeDuplicates(originalArray, objKey) {
      var trimmedArray = [];
      var values = [];
      var value;
      for (var i = 0; i < originalArray.length; i++) {
        value = originalArray[i][objKey];
        if (values.indexOf(value) === -1) {
          trimmedArray.push(originalArray[i]);
          values.push(value);
        }
      }
      return trimmedArray;
    };

    // const checkPageHit = function(pageData, results) {
    //   //Not yet accounting for capitals
    //   const boringWords = [
    //     'favourite',
    //     'world',
    //     'name',
    //     'this',
    //     'plan',
    //     'need',
    //     'best',
    //     'like',
    //     'the',
    //     'are',
    //     'is',
    //     'my',
    //     'my',
    //   ]
    //   const hits = []
    //   results.forEach(function(result, i) {
    //     log.trace('---')
    //     log.trace(i)
    //     var count = []
    //     result.context.forEach(function(c) {
    //       if (pageData.pageText.indexOf(c.value) > -1
    //       && hits.indexOf(result.objectID) == -1
    //       && c.value && c.value.length > 3
    //       && boringWords.indexOf(c.value) == -1
    //       && count.indexOf(c.value) == -1) {
    //         log.trace(c.value)
    //         count.push(c.value)
    //         (c.value.match(/ /g) || []).forEach(function() {
    //           count.push(c.value)
    //         })
    //       }
    //     })
    //     if (count.length > 2) {
    //       log.trace(result.sentence)
    //       hits.push(result)
    //     }
    //     log.trace('---')
    //   })
    //
    //   // return hits
    //   //Force no hits
    //   return []
    // }

    // const checkPageReminder = function(userID, pageData) {
    //   const d = Q.defer()
    //   log.trace(pageData)
    //   const urlRoot = pageData.baseUrl.replace('.com','').replace('.co.uk','').replace('.org','')
    //   const params = {
    //     query: '',
    //     filters: 'userID: ' + userID + ' AND (triggerUrl: ' + urlRoot + ' OR triggerUrl: ' + urlRoot + '.com OR triggerUrl: ' + urlRoot + '.co.uk OR triggerUrl: ' + urlRoot + '.org OR triggerURL: ' + urlRoot + ' OR triggerURL: ' + urlRoot + '.com OR triggerURL: ' + urlRoot + '.co.uk OR triggerURL: ' + urlRoot + '.org)'
    //   }
    //   log.trace('params')
    //   log.trace(params)
    //   advancedSearch(params)
    //   .then(function(reminders) {
    //     log.trace('reminders')
    //     log.trace(reminders)
    //     d.resolve(reminders)
    //   }).catch(function(e) {
    //     d.reject(e)
    //   })
    //   return d.promise
    // }

    this.getCard = chunkGet;
    this.advancedSearch = advancedSearch;
    this.searchCards = searchCards;
    this.compoundSearch = compoundSearch;
    this.removeDuplicates = removeDuplicates;
    this.saveCard = saveCard;
    this.correctCard = correctCard;
    this.yieldCard = yieldCard;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Search);

/***/ }),

/***/ "I4t6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__explorer_ibutton_vue__ = __webpack_require__("r+yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scripts_kloudless_authenticator_js__ = __webpack_require__("BEaQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global Kloudless */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  props: ['organisation', 'auth'],
  data: function data() {
    return {
      noOrg: true,
      doneMessage: false
    };
  },

  components: {
    ibutton: __WEBPACK_IMPORTED_MODULE_0__explorer_ibutton_vue__["a" /* default */]
  },
  computed: {
    organisationID: {
      get: function get() {
        return this.organisation.id;
      },
      set: function set(val) {
        this.organisation.id = val;
      }
    },
    authButtonText: function authButtonText() {
      var self = this;
      var text;
      switch (self.auth.authState) {
        case 'loggedIn':
          text = 'Sign out';
          break;
        case 'loggedOut':
          text = 'Sign in with Google';
          break;
        case 'pending':
          text = 'Working...';
          break;
      }
      return text;
    }
  },
  created: function created() {
    if (this.organisationID) this.noOrg = false;
  },
  methods: {
    connectSource: function connectSource() {
      var self = this;
      var params = {
        'client_id': '245u1N7lejDTHB0VtkNReEIpUItQLEs67I20xL0XD5DN0QDj',
        'scope': 'gdrive:normal.storage'
      };
      var auth = Kloudless.authenticator(null, params, self.addSource);
      auth.launch();
    },
    addSource: function addSource(result) {
      console.log(result);
      var self = this;
      self.doneMessage = true;
      if (!self.addingSource) {
        self.addingSource = true;
        // axios.post('http://localhost:5050/add-source', {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('//savvy-nlp--staging.herokuapp.com/add-source', {
          organisationID: self.organisation.id === 'connect' ? getParameterByName('org') : self.organisation.id,
          source: result
        }).then(function (res) {
          self.addingSource = false;
          console.log(res.data.results);
        }).catch(function (e) {
          self.addingSource = false;
          console.log(e);
        });
      }
    }
  }
});

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/***/ }),

/***/ "IICg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_explorer_vue__ = __webpack_require__("j4tA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57fcb4fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_explorer_vue__ = __webpack_require__("j21t");
function injectStyle (ssrContext) {
  __webpack_require__("CEdw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_explorer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57fcb4fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_explorer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IPVE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K31e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("I4t6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ceda13c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("go5a");
function injectStyle (ssrContext) {
  __webpack_require__("Ea6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ceda13c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LkkW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ editable: !(_vm.editable === false) },attrs:{"contenteditable":!(_vm.editable === false)},on:{"input":_vm.update}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NoQb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OFKv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__ = __webpack_require__("8LWO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5155e695_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__ = __webpack_require__("RNLm");
function injectStyle (ssrContext) {
  __webpack_require__("NoQb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5155e695_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OZcw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_billing_vue__ = __webpack_require__("hZYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_805cb8c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_billing_vue__ = __webpack_require__("sZvn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_billing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_805cb8c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_billing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OfX1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QMze":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__explorer_ibutton_vue__ = __webpack_require__("r+yu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global Kloudless */



// import '../scripts/kloudless.authenticator.js'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Files',
  props: ['organisation', 'auth'],
  data: function data() {
    return {
      files: [],
      showingConnect: false,
      addingSource: false
    };
  },

  components: {
    ibutton: __WEBPACK_IMPORTED_MODULE_3__explorer_ibutton_vue__["a" /* default */],
    icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__["a" /* default */]
  },
  created: function created() {
    this.getFiles();
  },
  methods: {
    toggleConnect: function toggleConnect() {
      this.showingConnect = !this.showingConnect;
    },
    connectSource: function connectSource() {
      var self = this;
      var params = {
        'client_id': '245u1N7lejDTHB0VtkNReEIpUItQLEs67I20xL0XD5DN0QDj',
        'scope': 'gdrive:normal.storage'
      };
      var auth = Kloudless.authenticator(null, params, self.addSource);
      auth.launch();
    },
    addSource: function addSource(result) {
      console.log(result);
      var self = this;
      if (!self.addingSource) {
        self.addingSource = true;
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('http://localhost:5000/add-source', {
          // axios.post('//savvy-nlp--staging.herokuapp.com/add-source', {
          organisationID: self.organisation.id,
          source: result
        }).then(function (res) {
          self.addingSource = false;
          console.log(res.data.results);
        }).catch(function (e) {
          self.addingSource = false;
          console.log(e);
        });
      }
    },
    getFiles: function getFiles() {
      // Dummy Data
      this.files = [{
        name: 'Competitor analysis'
      }, {
        name: 'Marketing spec'
      }, {
        name: 'Onboarding sheet'
      }, {
        name: 'Persona Brief'
      }];
    }
  }
});

/***/ }),

/***/ "RNLm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],attrs:{"autofocus":"","type":"text","placeholder":"Search for cards..."},domProps:{"value":(_vm.query)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.clearResults),expression:"clearResults"}],staticClass:"results"},_vm._l((_vm.results),function(result){return _c('cardlet',{key:result.objectID,attrs:{"editable":false,"card":result,"editing":false},on:{"cardletClick":_vm.selectResult}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RWjT":
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),

/***/ "Rr7d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RzXt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Pie */],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* mixins */].reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    var self = this;
    this.renderChart(self.chartData, self.options);
  }
});

/***/ }),

/***/ "TdAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

// This page expects the user to be logged in, and then allows them to confirm the organisation they're trying to join
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Join',
  props: ['organisation', 'auth'],
  data: function data() {
    return {
      noOrg: true,
      errorMessage: ''
    };
  },

  computed: {
    organisationID: {
      get: function get() {
        return this.organisation.id;
      },
      set: function set(val) {
        this.organisation.id = val;
      }
    }
  },
  created: function created() {
    if (this.organisationID) this.noOrg = false;
  },
  methods: {
    joinOrg: function joinOrg() {
      var _this = this;

      var self = this;
      self.auth.joinOrg(self.organisationID).then(function (res) {}).catch(function (e) {
        // Unable to join organisation, probably cos there's no invite
        _this.errorMessage = "Unfortunately you're not yet invited to this organisation - ask your team manager to invite you!";
      });
    }
  }
});

/***/ }),

/***/ "Twbz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join"},[(_vm.noOrg)?_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.organisationID),expression:"organisationID"}],attrs:{"autofocus":"","type":"text","placeholder":"myorg"},domProps:{"value":(_vm.organisationID)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.joinOrg($event)},"input":function($event){if($event.target.composing){ return; }_vm.organisationID=$event.target.value}}}),_vm._v(".heysavvy.com")]):_vm._e(),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.auth.authState == 'pending'},on:{"click":_vm.joinOrg}},[_vm._v("Join "),_c('b',[_vm._v(_vm._s(_vm.organisationID))]),_vm._v(" organisation")]),_vm._v(" "),(_vm.errorMessage.length)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U2Li":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__ = __webpack_require__("hrwk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f33fe90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__ = __webpack_require__("b0iR");
function injectStyle (ssrContext) {
  __webpack_require__("uml9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f33fe90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U6LC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Files',
  props: {
    user: {
      type: Object,
      default: {
        uid: '01234',
        data: {
          name: {
            first: 'Matthew',
            last: 'Morley'
          },
          email: 'matt@explaain.com'
        }
      }
    }
  },
  data: function data() {
    return {};
  },

  created: function created() {
    this.getSettings();
  },
  methods: {
    getSettings: function getSettings() {}
  }
});

/***/ }),

/***/ "UEHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V4dX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Analytics"}},[_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("View how your company knowledge is being used, where and by whom.")]),_vm._v(" "),_c('div',{staticClass:"graph-grid"},[_c('div',{staticClass:"block"},[_c('div',{staticClass:"graph-card"},[_c('chart',{staticClass:"wrapper",attrs:{"base":_vm.base,"title":"Most Active Users","type":'pie-chart',"options":{ color: '#CF60AA', sumMethod: 'blocks' },"query":{ start: '2017-11-02', event: 'Card Clicked', properties: ['cardID']  }}})],1)]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('div',{staticClass:"graph-card"},[_c('chart',{staticClass:"wrapper",attrs:{"base":_vm.base,"title":"Most popular searches","type":'bar-chart',"options":{ color: '#DA5FE6', sumMethod: 'blocks', order: 'desc', ignoreLabels: ['', '1'] },"query":{ start: '2017-11-03', event: 'Searched',  properties: ['searchQuery'], limit: 7 }}})],1)]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('div',{staticClass:"graph-card"},[_c('chart',{staticClass:"wrapper",attrs:{"base":_vm.base,"title":"User Activity over Time","type":'line-chart',"options":{ color: '#E65F76' },"query":{ start: '2017-11-05', event: 'User logged in' }}})],1)]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('div',{staticClass:"graph-card"},[_c('chart',{staticClass:"wrapper",attrs:{"base":_vm.base,"title":"Content Overview","type":'bar-chart',"options":{ color: '#DC685B' },"query":{ start: '2017-11-03', event: 'Card Created' }}})],1)]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('div',{staticClass:"graph-card"},[_c('chart',{staticClass:"wrapper",attrs:{"base":_vm.base,"title":"Team Usage Over Time","type":'line-chart',"options":{ color: 'rgb(100, 84, 244)' },"query":{ start: '2017-11-03', event: 'Card Clicked' }}})],1)]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('div',{staticClass:"graph-card"},[_c('chart',{staticClass:"wrapper",attrs:{"base":_vm.base,"title":"Savvy Employees","type":'line-chart',"options":{ color: '#AD5BDC', sumMethod: 'blocks', legend: true },"query":{ start: '2017-11-03', event: 'Card Created', properties: ['userID'] }}})],1)]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('div',{staticClass:"graph-card"},[_c('chart',{staticClass:"wrapper",attrs:{"base":_vm.base,"title":"Most Popular Cards","type":'bar-chart',"options":{ color: '#DA5FE6', sumMethod: 'blocks', order: 'desc' },"query":{ start: '2017-11-03',event: 'Card Clicked',  properties: ['description'], limit: 4 }}})],1)]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('div',{staticClass:"graph-card"},[_c('chart',{staticClass:"wrapper",attrs:{"base":_vm.base,"title":"Team Adoption","type":'bar-chart',"options":{ color: '#CF60AA', sumMethod: 'blocks' },"query":{ start: '2017-11-03', event: 'Card Clicked',  properties: ['userID'] }}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',{staticClass:"emoji"},[_vm._v("📈")]),_vm._v(" Analytics")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XMM3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('ibutton',{staticClass:"refresh",attrs:{"icon":"refresh","text":"Refresh","click":_vm.fetchData}}),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c(_vm.type,{tag:"component",attrs:{"chartData":_vm.data,"options":_vm.computedOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y4fr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:{'sidebar-true': _vm.sidebar}},[(!_vm.organisation || !_vm.organisation.id)?_c('section',{staticClass:"chooseOrg"},[_c('h3',[_vm._v("Hello! 👋 Please enter your organisation:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.organisationID),expression:"organisationID"}],attrs:{"type":"text","placeholder":"organisation_id"},domProps:{"value":(_vm.organisationID)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.selectOrganisation($event)},"input":function($event){if($event.target.composing){ return; }_vm.organisationID=$event.target.value}}}),_vm._v(".heysavvy.com\n    "),_c('button',{staticClass:"highlight",attrs:{"type":"button","name":"button"},on:{"click":_vm.selectOrganisation}},[_vm._v("Select Organisation")]),_vm._v(" "),(_vm.orgLoading)?_c('div',{staticClass:"spinner-div"},[_c('icon',{staticClass:"fa-spin fa-3x",attrs:{"name":"spinner"}})],1):_vm._e(),_vm._v(" "),(_vm.errorMessage.length)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.organisation && _vm.organisation.id)?_c('explorer',{attrs:{"plugin":_vm.plugin,"sidebar":_vm.sidebar,"logo":_vm.logo,"firebaseConfig":_vm.firebaseConfig,"algoliaParams":_vm.algoliaParams,"authorParams":_vm.authorParams,"local":_vm.local,"organisation":_vm.organisation,"auth":_vm.auth,"testing":_vm.testing},on:{"closeDrawer":_vm.closeDrawer}},[_c('div',{staticClass:"chrome-header",attrs:{"slot":"header"},slot:"header"},[_c('img',{staticClass:"savvy-logo",attrs:{"src":"/images/logo.png","alt":""}})])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_login__ = __webpack_require__("K31e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_join__ = __webpack_require__("zbyJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home__ = __webpack_require__("wUZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_analytics__ = __webpack_require__("ct+e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_notifications__ = __webpack_require__("64m6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_explorer_explorer__ = __webpack_require__("IICg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_teams__ = __webpack_require__("fQs2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_files__ = __webpack_require__("6Wec");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_settings__ = __webpack_require__("zetg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_billing__ = __webpack_require__("OZcw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_help__ = __webpack_require__("+23j");



// Components for dashboard












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var firebaseConfig = {
  apiKey: 'AIzaSyBU0SEu3orHAoJ5eqxIJXS2VfyqXm1HoMU',
  authDomain: 'forgetmenot-1491065404838.firebaseapp.com',
  databaseURL: 'https://forgetmenot-1491065404838.firebaseio.com',
  projectId: 'forgetmenot-1491065404838',
  storageBucket: '',
  messagingSenderId: '400087312665'
};
var algoliaParams = { // Need to fetch these from app.vue to avoid duplication!
  appID: 'D3AE3TSULH'
  // apiKey: '2b8406f84cd4cc507da173032c46ee7b',
  // index: 'Savvy'
};
var authorParams = {
  // url: 'https://forget-me-not--app.herokuapp.com/api/memories',
  // url: '//forget-me-not--staging.herokuapp.com/api/memories',
  // url: '//localhost:3000/api/memories',
  url: '//' + (Object({"NODE_ENV":"production"}).BACKEND_URL || 'forget-me-not--staging.herokuapp.com') + '/api/memories',
  importUrl: '//' + (Object({"NODE_ENV":"production"}).BACKEND_URL || 'forget-me-not--staging.herokuapp.com') + '/api/import'
  // var userID = '101118387301286232222'
};var logo = '../../assets/logo.png';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_login__["a" /* default */]
  }, {
    path: '/join',
    name: 'Join',
    component: __WEBPACK_IMPORTED_MODULE_3__components_join__["a" /* default */]
  }, {
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_4__components_home__["a" /* default */],
    meta: { requiresAuth: true }
  }, {
    path: '/analytics',
    component: __WEBPACK_IMPORTED_MODULE_5__components_analytics__["a" /* default */],
    meta: { requiresAuth: true }
  }, {
    path: '/notifications',
    component: __WEBPACK_IMPORTED_MODULE_6__components_notifications__["a" /* default */],
    meta: { requiresAuth: true }
  }, {
    path: '/card-manager',
    component: __WEBPACK_IMPORTED_MODULE_7__components_explorer_explorer__["a" /* default */],
    props: function props(route) {
      return { firebaseConfig: firebaseConfig, algoliaParams: algoliaParams, authorParams: authorParams, logo: logo };
    },
    meta: { requiresAuth: true }
  }, {
    path: '/teams',
    component: __WEBPACK_IMPORTED_MODULE_8__components_teams__["a" /* default */],
    meta: { requiresAuth: true }
  }, {
    path: '/files',
    component: __WEBPACK_IMPORTED_MODULE_9__components_files__["a" /* default */],
    meta: { requiresAuth: true }
  }, {
    path: '/settings',
    component: __WEBPACK_IMPORTED_MODULE_10__components_settings__["a" /* default */],
    meta: { requiresAuth: true }
  }, {
    path: '/billing',
    component: __WEBPACK_IMPORTED_MODULE_11__components_billing__["a" /* default */]
  }, {
    path: '/help',
    component: __WEBPACK_IMPORTED_MODULE_12__components_help__["a" /* default */]
  }]
});

console.log(router.currentRoute.path);
router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    var user;
    try {
      user = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].globalGetUser();
    } catch (e) {
      user = null;
    }
    console.log(user);
    console.log('from', from);
    if (!user || !user.auth) {
      // Needs to actually check auth.loggedIn() or something
      next({
        path: '/login',
        query: from.query.redirect ? { redirect: from.query.redirect || to.fullPath } : {}
      });
    } else if (!user.data) {
      next({
        path: '/join',
        query: from.query.redirect ? { redirect: from.query.redirect || to.fullPath } : {}
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Yodf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YsCb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pci.7818eb9.png";

/***/ }),

/***/ "ZRHb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__explorer_ibutton_vue__ = __webpack_require__("r+yu");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Teams',
  props: ['organisation', 'auth'],
  data: function data() {
    return {
      teams: [],
      users: {},
      showingNewUser: false,
      showingJoinTeam: false,
      newUser: {
        email: '',
        name: {
          first: '',
          last: ''
        }
      }
    };
  },

  components: {
    ibutton: __WEBPACK_IMPORTED_MODULE_4__explorer_ibutton_vue__["a" /* default */],
    icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon_vue__["a" /* default */]
  },
  computed: {
    teamUsers: function teamUsers() {
      // This is created by inserting the relevant user from this.users into this.teams
      var self = this;
      var teamUsers = {};
      self.users.forEach(function (user) {
        user.teams.forEach(function (team) {
          var teamUser = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
          teamUser.role = team.role;
          teamUsers[team.team] ? teamUser.role === 'manager' ? teamUsers[team.team].unshift(teamUser) : teamUsers[team.team].push(teamUser) : teamUsers[team.team] = [teamUser];
        });
      });
      // self.teams.forEach(team => {
      //   teamUsers[team.id] = team.users.map(userID => {
      //     return self.users[userID]
      //   })
      // })
      return teamUsers; // Will this have trouble refreshing? i.e. deep watch
    }
  },

  created: function created() {
    this.getTeams();
  },
  methods: {
    inviteNewUser: function inviteNewUser() {
      // Use: this.newUserEmail
    },
    toggleNewUser: function toggleNewUser() {
      this.showingNewUser = !this.showingNewUser;
    },
    getTeams: function getTeams() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('http://localhost:3000/api/user/getTeams', {
        organisationID: self.organisation.id,
        // Should use self.auth.user.refreshUserToken() here!
        user: { uid: self.auth.user.uid, idToken: self.auth.user.getAccessToken() }
      }).then(function (res) {
        console.log(res);
      }).catch(function (e) {
        console.log(e);
      });
      // Dummy Data
      this.teams = [{
        id: 'team1',
        name: 'Sales Team'
      }, {
        id: 'team2',
        name: 'Marketing Team'
      }];
      this.users = [{
        name: 'Adam',
        email: 'adam@company.org',
        teams: [{
          team: 'team1',
          role: 'member'
        }]
      }, {
        name: 'Boris',
        email: 'boris@company.org',
        teams: [{
          team: 'team1',
          role: 'member'
        }, {
          team: 'team2',
          role: 'manager'
        }]
      }, {
        name: 'Callum',
        email: 'callum@company.org',
        teams: [{
          team: 'team1',
          role: 'manager'
        }]
      }, {
        name: 'Dom',
        email: 'dom@company.org',
        teams: [{
          team: 'team2',
          role: 'member'
        }]
      }];
    }
  }
});

/***/ }),

/***/ "ZvuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardlet",on:{"click":function($event){$event.stopPropagation();_vm.cardletClick($event)}}},[(_vm.editing)?_c('ibutton',{staticClass:"drag",attrs:{"icon":"bars","text":""}}):_vm._e(),_vm._v(" "),(_vm.editing)?_c('ibutton',{staticClass:"remove",attrs:{"icon":"close","text":"","click":_vm.removeCardlet}}):_vm._e(),_vm._v(" "),_c('editable-markdown',{class:{ greyed: _vm.greyed },attrs:{"content":_vm.text,"editable":_vm.editing && _vm.editable},on:{"update":function($event){_vm.card.content.description = $event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aj6L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_q__ = __webpack_require__("/Luh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* global chrome */




// import Algolia from 'algoliasearch'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

var Author = {
  install: function install(Vue, options) {
    console.log(options);
    var url = options.url;
    this.plugin = options.plugin;
    console.log(url);

    var importFromDrive = function importFromDrive(user) {
      var d = __WEBPACK_IMPORTED_MODULE_1_q___default.a.defer();
      Vue.axios.post(options.importUrl, user).then(function (response) {
        d.resolve(response);
      }).catch(function (e) {
        console.log(e);
        d.reject(e);
      });
      return d.promise;
    };

    var saveCard = function saveCard(data) {
      var d = __WEBPACK_IMPORTED_MODULE_1_q___default.a.defer();
      if (this.plugin) chrome.runtime.sendMessage({ action: 'saveCard', url: url, data: data }, function (response) {
        d.resolve(response);
      });else Vue.axios.post(url, data).then(function (response) {
        console.log(response);
        d.resolve(response);
      }).catch(function (e) {
        d.reject(e);
      });
      return d.promise;
    };

    /* To Remove -- START */
    var createCard = function createCard(data) {
      var d = __WEBPACK_IMPORTED_MODULE_1_q___default.a.defer();
      console.log('data: ', data);
      Vue.axios.post(url, data).then(function (response) {
        console.log('Card successfully created');
        console.log(response);
        d.resolve(response);
      }).catch(function (e) {
        d.reject(e);
      });
      return d.promise;
    };

    var updateCard = function updateCard(data) {
      var d = __WEBPACK_IMPORTED_MODULE_1_q___default.a.defer();
      console.log('data: ', data);
      Vue.axios.post(url, data).then(function (response) {
        console.log('Card successfully edited');
        console.log(response);
        d.resolve(response);
      }).catch(function (e) {
        console.log(e);
        d.reject(e);
      });
      return d.promise;
    };
    /* To Remove -- END */

    var deleteCard = function deleteCard(data) {
      var d = __WEBPACK_IMPORTED_MODULE_1_q___default.a.defer();
      console.log('data: ', data);
      Vue.axios.delete(url, { params: data }).then(function (response) {
        console.log('Card successfully deleted');
        console.log(response);
        // data.callback('Card deleted!')
        // self.showAlert('success', 2000, 'Card deleted!')
        d.resolve();
      }).catch(function (e) {
        console.log(e);
        d.reject();
      });
      return d.promise;
    };

    // const deleteByQuery = function(data) {
    //   const d = Q.defer()
    //   const self = this
    //   console.log('data: ', data)
    //   Vue.axios.delete(url, {params: data})
    //   .then((response) => {
    //     console.log('All user cards successfully deleted')
    //     console.log(response)
    //     d.resolve()
    //   }).catch(function (e) {
    //     console.log(e)
    //     d.reject()
    //   })
    //   return d.promise
    // }

    this.importFromDrive = importFromDrive;
    this.saveCard = saveCard;
    this.createCard = createCard;
    this.updateCard = updateCard;
    this.deleteCard = deleteCard;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Author);

/***/ }),

/***/ "b0iR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card shadow",class:{ highlight: _vm.highlight || _vm.card.highlight, editing: _vm.editing, updating: _vm.updating, full: _vm.full },on:{"mouseover":_vm.cardMouseover,"mouseout":_vm.cardMouseout,"click":function($event){$event.stopPropagation();_vm.cardClick($event)}}},[_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(_vm.fullText),expression:"fullText"}],staticClass:"copy",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.copy($event)}}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.copyIcon}}),_vm._v("Copy")]),_vm._v(" "),((_vm.full && _vm.card.highlight) || _vm.card.content.title || _vm.card.content.description)?_c('div',{staticClass:"main"},[(_vm.full && _vm.card.highlight)?_c('div',{staticClass:"label"},[(_vm.card.highlight)?_c('span',{staticClass:"top-hit"},[_c('icon',{attrs:{"name":"bolt"}}),_vm._v(" Top Hit")],1):_vm._e(),_c('span',{staticClass:"type"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content",on:{"click":_vm.linkClick}},[(_vm.card.content.title || _vm.editing)?_c('editable-markdown',{staticClass:"title",attrs:{"content":_vm.card.content.title,"editable":_vm.editing,"placeholder":"Title"},on:{"update":function($event){_vm.card.content.title = $event}}}):_vm._e(),_vm._v(" "),_c('editable-markdown',{style:({'font-size': _vm.fontSize }),attrs:{"content":_vm.text,"editable":_vm.editing},on:{"update":function($event){_vm.text = $event}}}),_vm._v(" "),(_vm.listCards.length || _vm.editing)?_c('draggable',{staticClass:"list",attrs:{"options":{ disabled: !_vm.editing, handle: '.drag', draggable: '.cardlet' }},model:{value:(_vm.listCards),callback:function ($$v) {_vm.listCards=$$v},expression:"listCards"}},[_vm._l((_vm.listCards),function(item){return _c('cardlet',{key:item.objectID,attrs:{"editing":_vm.editing,"card":item},on:{"cardletClick":_vm.cardletClick,"remove":_vm.removeListItem}})}),_vm._v(" "),(_vm.editing)?_c('section',{staticClass:"buttons"},[_c('ibutton',{staticClass:"left",attrs:{"icon":"plus","text":"Create List Item","click":_vm.addListItem}}),_vm._v(" "),_c('ibutton',{staticClass:"right",class:{selected: _vm.showListSearch},attrs:{"icon":"search","text":"Insert Card Into List","click":_vm.toggleListSearch}}),_vm._v(" "),(_vm.showListSearch)?_c('search',{attrs:{"allCards":_vm.allCards,"setCard":_vm.setCard,"auth":_vm.auth},on:{"select":_vm.addListItem}}):_vm._e()],1):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.full && _vm.card.attachments && _vm.card.attachments[0])?_c('img',{attrs:{"src":_vm.card.attachments[0].url}}):_vm._e()],1),_vm._v(" "),(_vm.full && _vm.card.pending)?_c('div',{staticClass:"pending"},[_c('i',[_vm._v("This card has changes pending review")]),_vm._v(" "),_c('ibutton',{staticClass:"small",attrs:{"icon":"eye","text":"Show Pending Changes","click":_vm.togglePending}}),_vm._v(" "),(_vm.showPending)?_c('div',[_c('b',[_vm._v("Pending:")]),_c('br'),_vm._v("\n        "+_vm._s(_vm.card.pending[0].description)+"\n      ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.card)?_c('p',{staticClass:"spinner"},[_c('icon',{staticClass:"fa-spin fa-3x",attrs:{"name":"refresh"}})],1):_vm._e(),_vm._v(" "),(_vm.full && _vm.card.extractedFrom)?_c('p',{staticClass:"extractedFrom"},[_vm._v("Extracted from "),_c('a',{attrs:{"href":_vm.card.extractedFrom.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.card.extractedFrom.title))])]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.card.files),function(file, i){return (_vm.card.files)?_c('a',{staticClass:"file",attrs:{"target":"_blank","href":file.url || 'https://docs.google.com/document/d/15WQ-3weCzF7kmi9FzMJwN6XH1K_ly6cvBM_NuFZtJsw/edit?usp=sharing'}},[_c('img',{attrs:{"src":_vm.fileIcons[i],"alt":""}}),_vm._v(" "),_c('h4',[_c('vue-markdown',{attrs:{"watches":['card.files'],"source":file.title,"linkify":false,"anchorAttributes":{target: '_blank'}}})],1),_vm._v(" "),_c('h5',[_vm._v("📂 "+_vm._s(file.folder || _vm.auth && _vm.auth.user && _vm.auth.user.data && _vm.auth.user.data.organisation && _vm.auth.user.data.organisation.id + ' Drive' || 'Explaain Drive'))])]):_vm._e()}),_vm._v(" "),(_vm.full)?_c('footer',[(_vm.card.sources && _vm.card.sources.length)?_c('div',{staticClass:"sources"},[_vm._v("\n      Source"+_vm._s(_vm.card.sources.length > 1 ? 's' : '')+": "),_vm._l((_vm.card.sources),function(source){return _c('a',{attrs:{"href":source.url,"target":"_blank"}},[_vm._v(_vm._s(source.name))])})],2):_vm._e(),_vm._v(" "),(!_vm.reacted && !_vm.explaain)?_c('div',{staticClass:"buttons reaction"},[_c('p',[_vm._v("How well did this match what you were looking for?")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.reaction('great')}}},[_vm._v("😍")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.reaction('ok')}}},[_vm._v("😐")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.reaction('bad')}}},[_vm._v("😢")])]):_vm._e(),_vm._v(" "),(_vm.reacted && !_vm.explaain)?_c('div',{staticClass:"buttons reaction"},[_c('p',[_vm._v("Thanks for letting us know! Our AI uses this feedback to get smarter 😎")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer-logo"},[_vm._v(_vm._s(_vm.explaain ? 'Explaain' : 'Savvy'))])]):_vm._e(),_vm._v(" "),(_vm.pendingApproval)?_c('ibutton',{staticClass:"approve",attrs:{"icon":"check","text":"Approve"}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b2/t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aicpa.88d66a1.png";

/***/ }),

/***/ "bGfq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ibutton_vue__ = __webpack_require__("r+yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editable_vue__ = __webpack_require__("srgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editable_markdown_vue__ = __webpack_require__("uE8u");
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['card', 'editing', 'editable'],
  data: function data() {
    return {};
  },
  computed: {
    cardletEditable: function cardletEditable() {
      return this.editing && this.editable;
    },
    text: {
      get: function get() {
        var text = this.card.content.description || '';
        var snippetLength = 60;
        var snippetStart = Math.max(text.indexOf('**') - snippetLength / 2, 0);
        return this.full ? text : text.trunc(snippetStart, snippetLength, true);
      },
      set: function set(val) {
        this.card.content.description = val;
      }
    },
    greyed: function greyed() {
      return this.text.indexOf('**') === -1;
    }
  },
  components: {
    icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__["a" /* default */],
    ibutton: __WEBPACK_IMPORTED_MODULE_2__ibutton_vue__["a" /* default */],
    editable: __WEBPACK_IMPORTED_MODULE_3__editable_vue__["a" /* default */],
    EditableMarkdown: __WEBPACK_IMPORTED_MODULE_4__editable_markdown_vue__["a" /* default */]
  },
  methods: {
    removeCardlet: function removeCardlet() {
      var self = this;
      self.$emit('remove', self.card);
    },
    cardletClick: function cardletClick() {
      var self = this;
      self.$emit('cardletClick', self.card);
    }
  }
});

String.prototype.trunc = function (start, length, useWordBoundary) {
  if (this.length <= length) return this;
  var subString = this.substr(start, length - 1);
  return (start > 0 ? '...' : '') + (useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '...';
};

/***/ }),

/***/ "bOqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['icon', 'text', 'click'],
  components: {
    icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },
  methods: {
    clickEvent: function clickEvent() {
      if (this.click) {
        this.click();
      }
    }
  }
});

/***/ }),

/***/ "ct+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_analytics_vue__ = __webpack_require__("uxU0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_118e8b4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_analytics_vue__ = __webpack_require__("V4dX");
function injectStyle (ssrContext) {
  __webpack_require__("8CGj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_analytics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_118e8b4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_analytics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (match, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "dY5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__explorer_ibutton_vue__ = __webpack_require__("r+yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__line_chart__ = __webpack_require__("9nIT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bar_chart__ = __webpack_require__("6UJy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pie_chart__ = __webpack_require__("RzXt");

//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);

var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; // January is 0!
var yyyy = today.getFullYear();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Chart',
  props: ['base', 'title', 'type', 'query', 'options'],
  data: function data() {
    return {
      data: {},
      todayFormatted: yyyy + '-' + mm + '-' + dd
    };
  },

  computed: {
    computedQuery: function computedQuery() {
      var result = this.query;
      result.organisationID = this.base.organisation.id; // || 'explaain'
      if (!result.end) result.end = this.todayFormatted;
      return result;
    },
    computedOptions: function computedOptions() {
      var result = this.options;
      result.legend = { display: !!result.legend };
      return result;
    }
  },
  components: {
    ibutton: __WEBPACK_IMPORTED_MODULE_4__explorer_ibutton_vue__["a" /* default */],
    'line-chart': __WEBPACK_IMPORTED_MODULE_5__line_chart__["a" /* default */],
    'bar-chart': __WEBPACK_IMPORTED_MODULE_6__bar_chart__["a" /* default */],
    'pie-chart': __WEBPACK_IMPORTED_MODULE_7__pie_chart__["a" /* default */]
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var self = this;
      var url = '//forget-me-not--staging.herokuapp.com/analytics/fetch';
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(url, self.computedQuery).then(function (response) {
        var data = {};
        var formattedData = {};
        switch (self.options.sumMethod) {
          case 'blocks':
            data = response.data.values;
            formattedData.labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data);
            formattedData.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).map(function (key) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data[key]).reduce(function (sum, dataKey) {
                return parseInt(sum) + parseInt(data[key][dataKey]);
              }, 0);
            });
            break;
          default:
            data = response.data.values[self.computedQuery.event];
            formattedData.labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).sort();
            formattedData.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).sort().map(function (key) {
              return data[key];
            });
        }
        if (self.options.order) {
          var combined = formattedData.labels.map(function (label, i) {
            return { label: label, data: formattedData.data[i] };
          });
          if (self.options.ignoreLabels !== undefined) combined = combined.filter(function (point) {
            return self.options.ignoreLabels.indexOf(point.label) === -1;
          });
          var ordered = combined.sort(function (a, b) {
            return self.options.order === 'desc' ? b.data - a.data : a.data - b.data;
          });
          formattedData.labels = ordered.map(function (dataPoint) {
            return dataPoint.label;
          });
          formattedData.data = ordered.map(function (dataPoint) {
            return dataPoint.data;
          });
        }
        self.data = {
          labels: formattedData.labels,
          datasets: [{
            label: self.computedQuery.event,
            backgroundColor: self.computedOptions.color,
            data: formattedData.data
          }]
          // console.log(self.data)
        };
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "eqfd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['submit', 'data'],
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__["mixin"]],
  components: {
    icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },
  methods: {
    submitEvent: function submitEvent() {
      this.$emit('close');
      this.$emit('submit', this.data);
    },
    away: function away() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "fQs2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teams_vue__ = __webpack_require__("ZRHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99585c26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teams_vue__ = __webpack_require__("zLqp");
function injectStyle (ssrContext) {
  __webpack_require__("tm6V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_teams_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99585c26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_teams_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gCcF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/connect.16b3d32.png";

/***/ }),

/***/ "go5a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('img',{staticClass:"image-main",attrs:{"src":__webpack_require__("gCcF"),"alt":""}}),_vm._v(" "),_c('h1',[_vm._v("Connect Savvy to Google Drive 🚀")]),_vm._v(" "),_c('h2',[_vm._v("Use the Savvy + Google Drive integration to securely search for files and answers within files, directly from within Slack.")]),_vm._v(" "),_c('p',{staticStyle:{"font-style":"italic"}},[_vm._v("\n    \"What are our brand guidelines?\"  ●  \n    \"Where is the privacy policy?\"  ●  \n    \"How do we issue a refund?\"\n  ")]),_vm._v(" "),(_vm.doneMessage)?_c('div',{staticClass:"done-message"},[_vm._v("\n    Thanks for connecting up your Google Drive! We're indexing your content right now and it'll be ready for you on Slack within a few minutes.\n  ")]):_vm._e(),_vm._v(" "),(!_vm.doneMessage)?_c('button',{staticClass:"connect",on:{"click":_vm.connectSource}},[_c('img',{attrs:{"src":__webpack_require__("suNf"),"alt":""}}),_c('span',[_vm._v("Google Drive")])]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"compliance",attrs:{"src":__webpack_require__("b2/t"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"compliance",attrs:{"src":__webpack_require__("YsCb"),"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h2zT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hZYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Billing',
  data: function data() {
    return {
      msg: 'Welcome to billing'
    };
  }
});

/***/ }),

/***/ "hrwk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loglevel__ = __webpack_require__("BvyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loglevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clipboards__ = __webpack_require__("Yk46");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_clipboards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_clipboards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_markdown__ = __webpack_require__("Xoog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ibutton_vue__ = __webpack_require__("r+yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cardlet_vue__ = __webpack_require__("t8wU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__editable_vue__ = __webpack_require__("srgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__editable_markdown_vue__ = __webpack_require__("uE8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__search_vue__ = __webpack_require__("OFKv");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import _ from 'lodash'











__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_clipboards___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['explaain', 'plugin', 'data', 'full', 'allCards', 'setCard', 'auth', 'pendingApproval', 'position', 'highlight'],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_5_vue_awesome_components_Icon_vue__["a" /* default */],
    VueMarkdown: __WEBPACK_IMPORTED_MODULE_6_vue_markdown___default.a,
    ibutton: __WEBPACK_IMPORTED_MODULE_8__ibutton_vue__["a" /* default */],
    Cardlet: __WEBPACK_IMPORTED_MODULE_9__cardlet_vue__["a" /* default */],
    Editable: __WEBPACK_IMPORTED_MODULE_10__editable_vue__["a" /* default */],
    Draggable: __WEBPACK_IMPORTED_MODULE_7_vuedraggable___default.a,
    Search: __WEBPACK_IMPORTED_MODULE_12__search_vue__["a" /* default */],
    EditableMarkdown: __WEBPACK_IMPORTED_MODULE_11__editable_markdown_vue__["a" /* default */]
  },
  data: function data() {
    return {
      card: {},
      tempListCards: {},
      editing: false,
      copyIcon: this.plugin ? './images/clipboard.svg' : './static/images/clipboard.svg',
      showListSearch: false,
      showPending: false,
      reacted: false
    };
  },
  computed: {
    updating: function updating() {
      return this.card.updating || false;
    },
    listCards: function listCards() {
      var self = this;
      var listCards = self.card._highlightResult && self.card._highlightResult.listCards || self.card.listCards || [];
      return listCards.map(function (content, i) {
        return {
          objectID: self.card.listItems[i],
          content: {
            description: content.value || content
          }
        };
      });
    },
    // listCards: {
    //   get: function() {
    //     const self = this
    //     return self.card.content.listItems ? self.card.content.listItems.map(function(objectID) {
    //       return self.tempListCards[objectID] || JSON.parse(JSON.stringify(self.allCards[objectID] || null)) || { content: { description: 'Card Not Found' } }
    //     }) : []
    //   },
    //   set: function(newValue) { // Doesn't get called for deep events which could cause issues
    //     const self = this
    //     self.card.content.listItems = newValue.map(function(listCard) {
    //       self.tempListCards[listCard.objectID] = listCard // Is having this here good practice?
    //       return listCard.objectID
    //     })
    //   }
    // },
    text: {
      get: function get() {
        var text = this.card.content.description || '';
        // if (!text || !text.length) console.log(text)
        var snippetLength = 100;
        var snippetStart = Math.max(text.indexOf('**') - snippetLength / 2, 0);
        return this.full ? text : text.trunc(snippetStart, snippetLength, true);
      },
      set: function set(val) {
        this.card.content.description = val;
      }
    },
    fileIcons: function fileIcons() {
      return this.card.files.map(function (file) {
        switch (file.mimeType) {
          case 'application/vnd.google-apps.document':
          case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return 'https://lh4.ggpht.com/-wROmWQVYTcjs3G6H0lYkBK2nPGYsY75Ik2IXTmOO2Oo0SMgbDtnF0eqz-BRR1hRQg=w300';
          case 'application/vnd.google-apps.spreadsheet':
          case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return 'http://icons.iconarchive.com/icons/dtafalonso/android-lollipop/512/Sheets-icon.png';
          case 'application/vnd.google-apps.presentation':
          case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return 'http://cliparting.com/wp-content/uploads/2017/07/Google-slides-icon-free-download-at-icons8-clipart.png';
          case 'application/pdf':
            return 'https://cdn1.iconfinder.com/data/icons/adobe-acrobat-pdf/154/adobe-acrobat-pdf-file-512.png';
          case 'image/png':
          case 'image/jpg':
          case 'image/jpeg':
          case 'image/gif':
            return 'https://cdn3.iconfinder.com/data/icons/faticons/32/picture-01-512.png';
          default:
            return 'https://cdn4.iconfinder.com/data/icons/48-bubbles/48/12.File-512.png';
        }
      });
    },
    fullText: function fullText() {
      return this.text + this.listCards.map(function (listCard) {
        return '\n- ' + listCard.content.description;
      });
    },
    fontSize: function fontSize() {
      // const self = this
      // return 16 + 2 * Math.floor(Math.min(5, 100 / (self.text.length))) + 'px'
      return 16 + 'px';
    }
  },
  watch: {
    data: {
      handler: function handler(val) {
        console.log('data data');
        console.log(this.editing);
        if (!this.editing) this.syncData();
      },
      deep: true
    },
    editing: function editing(val) {
      var self = this;
      if (val) self.listCards.forEach(function (listCard) {
        self.tempListCards[listCard.objectID] = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(listCard));
      });
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2_loglevel___default.a.debug(this.data.objectID);
    this.syncData();
    if (this.data.newlyCreated) this.editing = true;
  },
  methods: {
    syncData: function syncData() {
      this.card = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
    },
    linkClick: function linkClick(event) {
      var self = this;
      if (event.srcElement.nodeName === 'A') {
        event.stopPropagation();
        var myRegexp = /\[.*?\]\((.*?)\)/g;
        var match = myRegexp.exec(self.text);
        var toLayerKeys = [];
        while (match != null) {
          toLayerKeys.push(match[1].replace('#', ''));
          match = myRegexp.exec(self.text);
        }
        var data = {
          // type: 'link',
          toURI: event.srcElement.hash.replace('#', ''),
          fromPos: self.position,
          toLayerKeys: toLayerKeys
        };
        data.toPos = [data.fromPos[0] + 1, data.toLayerKeys.indexOf(data.toURI)];
        this.$emit('showCard', data);
      }
    },
    cardMouseover: function cardMouseover() {
      var self = this;
      this.$emit('cardMouseover', self.card);
    },
    cardMouseout: function cardMouseout() {
      var self = this;
      this.$emit('cardMouseout', self.card);
    },
    cardClick: function cardClick() {
      var self = this;
      console.log('cardClick');
      if (!this.editing) this.$emit('cardClick', self.card);

      var data = {
        // type: 'select',
        // toURI: event.srcElement.hash.replace('#', ''),
        fromPos: self.position,
        toPos: self.position
        // fromDOM: getCardDOM(triggerTarget),
        // toLayerKeys: toLayerKeys
      };
      this.$emit('showCard', data);
    },
    cardletClick: function cardletClick(card) {
      if (!this.editing) this.$emit('cardClick', card);
    },
    editCard: function editCard() {
      this.editing = true;
    },
    deleteCard: function deleteCard() {
      this.$emit('deleteCard', this.card.objectID);
    },
    cancelEdit: function cancelEdit() {
      this.syncData();
      this.editing = false;
      // self.tempListCards = {} ????
    },
    saveEdit: function saveEdit() {
      var self = this;
      self.card.content.listCards = self.listCards;
      self.listCards.forEach(function (listCard) {
        self.tempListCards[listCard.objectID] = listCard;
      });
      self.$emit('updateCard', self.card, function (data) {
        self.tempListCards = {};
        self.syncData(); // Shouldn't be necessary if data were properly being wtached deeply
      }, function (e) {
        console.log(e);
        self.tempListCards = {};
      });
      self.editing = false;
    },
    addListItem: function addListItem(card) {
      console.log(card);
      var self = this;
      if (!card) card = {
        objectID: 'TEMP_' + Math.floor(Math.random() * 10000000000),
        intent: 'storeMemory',
        content: {
          description: ''
        }
      };
      self.tempListCards[card.objectID] = card;
      if (!self.card.content.listItems) __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(self.card.content, 'listItems', []);
      self.card.content.listItems.push(card.objectID);
    },
    removeListItem: function removeListItem(data) {
      var listIndex = this.card.content.listItems.indexOf(data.objectID); // Doesn't account for same item appearing twice in list
      this.card.content.listItems.splice(listIndex, 1);
    },
    toggleListSearch: function toggleListSearch() {
      this.showListSearch = !this.showListSearch;
    },
    togglePending: function togglePending() {
      this.showPending = !this.showPending;
    },
    copy: function copy(e) {
      // The v-clipboard directive has already copied the text from the card - this function just shows the alert
      this.$emit('copy');
    },
    reaction: function reaction(_reaction) {
      var self = this;
      self.$emit('reaction', { reaction: _reaction, card: self.card });
      self.reacted = true;
    }
  }
});

String.prototype.trunc = function (start, length, useWordBoundary) {
  if (this.length <= length) return this;
  var subString = this.substr(start, length - 1);
  return (start > 0 ? '...' : '') + (useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '...';
};

/***/ }),

/***/ "j21t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explorer",class:{sidebar: _vm.sidebar}},[_c('div',{staticClass:"main",class:{mouseover : _vm.overMain},attrs:{"uid":"main"},on:{"mouseover":function($event){_vm.overMain = true},"mouseout":function($event){_vm.overMain = false}}},[_c('alert',{attrs:{"show":_vm.alertData.show,"type":_vm.alertData.type,"title":_vm.alertData.title}}),_vm._v(" "),(_vm.modal.show)?_c('modal',{attrs:{"data":_vm.modal},on:{"close":function($event){_vm.modal.show = false},"submit":_vm.modal.submit}}):_vm._e(),_vm._v(" "),(!_vm.$route.query.q)?_c('div',{staticClass:"header"},[_vm._t("header"),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"search",attrs:{"autofocus":"","type":"text","placeholder":_vm.searchPlaceholder},domProps:{"value":(_vm.query)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_c('br'),_vm._v(" "),_vm._t("buttons"),_vm._v(" "),(_vm.local)?_c('ibutton',{attrs:{"icon":"code","text":"Local","click":_vm.searchTempLocal}}):_vm._e(),_vm._v(" "),_c('ibutton',{attrs:{"icon":"history","text":"Recent","click":_vm.searchRecent}}),_vm._v(" "),_c('ibutton',{attrs:{"icon":"random","text":"Random","click":_vm.searchRandom}})],2):_vm._e(),_vm._v(" "),(_vm.$route.query.q)?_c('h2',[_vm._v("Your search results for \""+_vm._s(_vm.query)+"\":")]):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"masonry",rawName:"v-masonry"}],staticClass:"cards",attrs:{"transition-duration":"0.3s","item-selector":".card"}},[(_vm.loading && _vm.loader == -1)?_c('p',{staticClass:"spinner"},[_c('icon',{staticClass:"fa-spin fa-3x",attrs:{"name":"refresh"}})],1):_vm._e(),_vm._v(" "),(_vm.loader != -1)?_c('p',{staticClass:"loader-text"},[_vm._v("Importing and processing content...")]):_vm._e(),_vm._v(" "),(_vm.loader != -1)?_c('div',{staticClass:"loader"},[_c('div',{style:({ width: _vm.loader + '%' })})]):_vm._e(),_vm._v(" "),(_vm.loader != -1)?_c('p',{staticClass:"loader-card-text"},[_vm._v(_vm._s(_vm.loaderCards)+" cards generated")]):_vm._e(),_vm._v(" "),(_vm.pingCards.length)?_c('p',{staticClass:"cards-label"},[_vm._v("Match to content on the page 🙌")]):_vm._e(),_vm._v(" "),_vm._l((_vm.pingCards),function(card,index){return _c('card',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:card.objectID,attrs:{"plugin":_vm.plugin,"data":card,"full":false,"allCards":_vm.allCards,"setCard":_vm.setCard,"auth":_vm.auth},on:{"cardMouseover":_vm.cardMouseover,"cardMouseout":_vm.cardMouseout,"cardClick":_vm.cardClick,"updateCard":_vm.updateCard,"deleteCard":_vm.beginDelete,"reaction":_vm.reaction,"copy":_vm.copyAlert}})}),_vm._v(" "),(_vm.pingCards.length && _vm.cards.length)?_c('p',{staticClass:"cards-label"},[_vm._v("Other potentially relevant information:")]):_vm._e(),_vm._v(" "),_vm._l((_vm.cards),function(card,index){return _c('card',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:card.objectID,attrs:{"plugin":_vm.plugin,"data":card,"full":false,"allCards":_vm.allCards,"setCard":_vm.setCard,"auth":_vm.auth},on:{"cardMouseover":_vm.cardMouseover,"cardMouseout":_vm.cardMouseout,"cardClick":_vm.cardClick,"updateCard":_vm.updateCard,"deleteCard":_vm.beginDelete,"reaction":_vm.reaction,"copy":_vm.copyAlert}})}),_vm._v(" "),(!_vm.cards.length)?_c('p',{staticClass:"no-cards"},[_vm._v(_vm._s(_vm.noCardMessage))]):_vm._e()],2)],1),_vm._v(" "),_c('div',{staticClass:"popup",class:{ active: _vm.popupCards.length },on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.popupFrameClick($event)}}},[_c('ul',{staticClass:"cards",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.popupFrameClick($event)}}},[(_vm.popupLoading)?_c('p',{staticClass:"spinner"},[_c('icon',{staticClass:"fa-spin fa-3x",attrs:{"name":"spinner"}})],1):_vm._e(),_vm._v(" "),(_vm.popupCards.length > 1)?_c('div',{staticClass:"popup-back",on:{"click":_vm.popupBack,"mouseover":_vm.cardMouseoverFromPopup}},[_c('icon',{attrs:{"name":"arrow-left"}}),_vm._v(" Back to \""),_c('span',{staticClass:"name"},[_vm._v(_vm._s((_vm.popupCards[_vm.popupCards.length - 2].content.title || _vm.popupCards[_vm.popupCards.length - 2].content.description || '').substring(0, 30))+"...")]),_vm._v("\"")],1):_vm._e(),_vm._v(" "),(_vm.popupCards.length)?_c('card',{attrs:{"plugin":_vm.plugin,"data":_vm.popupCards ? _vm.popupCards[_vm.popupCards.length - 1] : {},"full":true,"allCards":_vm.allCards,"setCard":_vm.setCard,"auth":_vm.auth},on:{"cardMouseover":_vm.cardMouseoverFromPopup,"cardMouseout":_vm.cardMouseout,"cardClick":_vm.cardClickFromPopup,"updateCard":_vm.updateCard,"deleteCard":_vm.beginDelete,"reaction":_vm.reaction,"copy":_vm.copyAlert}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j4tA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loglevel__ = __webpack_require__("BvyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loglevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_q__ = __webpack_require__("/Luh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixpanel_browser__ = __webpack_require__("j9k2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mixpanel_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mixpanel_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_masonry__ = __webpack_require__("w/U7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__card_vue__ = __webpack_require__("U2Li");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ibutton_vue__ = __webpack_require__("r+yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modal_vue__ = __webpack_require__("ybKc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__alert_vue__ = __webpack_require__("olKB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_explaain_search_js__ = __webpack_require__("Huz3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_explaain_author_js__ = __webpack_require__("aj6L");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















// import SavvyImport from '../../plugins/savvy-import.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    card: __WEBPACK_IMPORTED_MODULE_11__card_vue__["a" /* default */],
    icon: __WEBPACK_IMPORTED_MODULE_8_vue_awesome_components_Icon_vue__["a" /* default */],
    ibutton: __WEBPACK_IMPORTED_MODULE_12__ibutton_vue__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_13__modal_vue__["a" /* default */],
    alert: __WEBPACK_IMPORTED_MODULE_14__alert_vue__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default.a
  },
  props: ['plugin', 'organisation', 'auth', 'logo', 'firebaseConfig', 'algoliaParams', 'authorParams', 'sidebar', 'local', 'testing'],
  data: function data() {
    return {
      pageCards: [],
      allCards: {},
      mainCardList: [],
      pingCards: [],
      popupCards: [],
      popupClicked: false,
      popupShowTimeout: null,
      popupCloseTimeout: null,
      overMain: false,
      loading: false,
      loader: -1,
      loaderCards: 0,
      popupLoading: false,
      query: '',
      lastQuery: '',
      modal: {
        show: false,
        text: ''
      },
      alertData: {
        show: false,
        type: '',
        title: ''
      },
      noCardMessage: 'Type above to search for cards'
    };
  },

  computed: {
    cards: function cards() {
      var self = this;
      var watchThis = self.allCards; // This does nothing other than force this function to watch for changes in self.allCards
      console.log(watchThis);
      return self.mainCardList ? self.mainCardList.map(function (objectID) {
        return self.allCards[objectID] || { content: { description: 'Card Not Found' } };
      }) : [];
    },
    searchPlaceholder: function searchPlaceholder() {
      return document.documentElement.clientWidth > 600 ? 'Find anything (like holiday pay, product specs and emojis)...' : 'Find anything...';
    }
  },
  created: function created() {
    console.log('Starting Explorer');
    var self = this;
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_masonry__["a" /* VueMasonryPlugin */]);
    console.log('self.algoliaParams', self.algoliaParams);
    console.log('self.auth', self.auth);
    console.log('self.auth.user', self.auth.user);
    self.auth.user.organisation = self.organisation;
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__plugins_explaain_search_js__["a" /* default */], self.algoliaParams, self.auth.user);
    self.authorParams.plugin = self.plugin;
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16__plugins_explaain_author_js__["a" /* default */], self.authorParams);

    // Vue.use(SavvyImport)
    self.modal.sender = self.auth.user.uid;
    self.modal.callback = self.modalCallback;
    self.$parent.$on('updateCards', self.updateCards);
    self.$parent.$on('getCard', self.getCard);
    self.$parent.$on('setLoading', self.setLoading);
    self.$parent.$on('closingDrawer', function () {
      self.closePopup(true);
    });
    self.$parent.$on('search', function (query) {
      self.search(self.$route.query.q);
      console.log('SEARCHSEARCHSEARCHSEARCHSEARCHSEARCHSEARCHSEARCHSEARCH');
    });
    // SavvyImport.beginImport()
    __WEBPACK_IMPORTED_MODULE_9_mixpanel_browser___default.a.init('e3b4939c1ae819d65712679199dfce7e', { api_host: 'https://api.mixpanel.com' });
    setTimeout(function () {
      console.log('SEARCHSEARCHSEARCHSEARCHSEARCH');
      if (self.$route.query.q) self.search(self.$route.query.q);else self.searchRandom();
    }, 200);
  },
  methods: {
    convertFileToCards: function convertFileToCards(body, file) {
      var cards = [];
      body.split(/(\r\n\r\n\r\n|\n\n\n|\r\r\r)/gm).forEach(function (chunk) {
        chunk = chunk.trim();
        if (chunk.length) {
          cards.push({
            description: chunk,
            extractedFrom: {
              title: file.name,
              url: file.webViewLink // Not yet working maybe?
            }
          });
        }
      });
      return cards;
    },
    getCard: function getCard(objectID) {
      var self = this;
      var card = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.allCards[objectID] || null));
      // if (!card)
      //   ExplaainSearch.getCard(objectID)
      //   .then(card => {
      //     self.allCards[objectID] = card
      //   })
      return card;
    },
    setCard: function setCard(objectID, card) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(self.allCards, objectID, card); // Forces this to be watched
    },
    setCardProperty: function setCardProperty(objectID, property, value) {
      var self = this;
      var card = self.allCards[objectID];
      card[property] = value;
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(self.allCards, objectID, card); // Forces this to be watched - not yet working, at least with 'updating'
    },
    cardMouseoverFromPopup: function cardMouseoverFromPopup(card) {
      clearTimeout(this.popupCloseTimeout);
      clearTimeout(this.popupShowTimeout);
    },
    cardMouseover: function cardMouseover(card) {
      var self = this;
      if (self.sidebar) {
        clearTimeout(self.popupCloseTimeout);
        clearTimeout(self.popupShowTimeout);
        if (self.popupClicked) self.popupShowTimeout = setTimeout(function () {
          self.popupClicked = false;
          self.openPopup(card);
        }, 1000);else self.openPopup(card);
      }
    },
    cardMouseout: function cardMouseout() {
      if (this.sidebar) {
        this.closePopup();
      }
    },
    cardClickFromPopup: function cardClickFromPopup(card) {
      this.cardClick(card, true);
    },
    cardClick: function cardClick(card, fromPopup) {
      var self = this;
      setTimeout(function () {
        // Is this timeout stil necessary?
        self.popupClicked = true;
        self.openPopup(card, fromPopup);
        __WEBPACK_IMPORTED_MODULE_9_mixpanel_browser___default.a.track('Card Clicked', {
          organisationID: self.organisation.id,
          userID: self.auth.user.uid,
          cardID: card.objectID,
          description: card.content.description,
          listItems: card.content.listItems
        });
      }, 1);
    },
    popupBack: function popupBack() {
      this.popupCards.pop();
    },
    popupClickaway: function popupClickaway(event) {
      var self = this;
      if (!this.sidebar) {
        self.closePopup();
      }
    },
    popupFrameClick: function popupFrameClick() {
      var self = this;
      console.log('popupFrameClick');
      if (this.sidebar) {
        self.closePopup(true);
        self.$emit('closeDrawer');
      } else {
        self.closePopup();
      }
    },
    openPopup: function openPopup(c, append) {
      var _this = this;

      console.log('openPopup');
      __WEBPACK_IMPORTED_MODULE_15__plugins_explaain_search_js__["a" /* default */].getCard(c.objectID).then(function (card) {
        console.log('ccccc', c);
        if (c._highlightResult) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(c._highlightResult).forEach(function (key) {
            console.log(key);
            if (key === 'fileTitle' && card.files && card.files.length) card.files[0].title = c._highlightResult[key].value;else card.content[key === 'content' ? 'description' : key] = c._highlightResult[key].value;
          });
        }
        console.log('card', card);
        if (append) {
          if (!_this.popupCards.length || _this.popupCards[_this.popupCards.length - 1].objectID !== c.objectID) _this.popupCards.push(card);
        } else _this.popupCards = [card];
      });
      clearTimeout(this.popupCloseTimeout);
    },
    closePopup: function closePopup(instantly) {
      console.log('closePopup');
      var self = this;
      self.editing = false; // This should be for every card so currently does nothing
      clearTimeout(self.popupCloseTimeout);
      if (this.sidebar && !instantly) {
        self.popupCloseTimeout = setTimeout(function () {
          self.popupClicked = false;
          self.popupCards = [];
        }, 1000);
      } else {
        self.popupClicked = false;
        this.popupCards = [];
      }
    },
    updateCards: function updateCards(data) {
      var self = this;
      self.loading = false;
      if (data && data.cards) {
        self.pingCards = data.cards.pings.map(function (card) {
          return card.card;
        });
        __WEBPACK_IMPORTED_MODULE_4_loglevel___default.a.debug(1, self.pingCards);
        // self.cards = data.cards.memories
        self.mainCardList = data.cards.memories.map(function (card) {
          return card.card.objectID;
        });
        __WEBPACK_IMPORTED_MODULE_4_loglevel___default.a.debug(2, self.mainCardList);
        // Need to add to allCards?
        data.cards.memories.forEach(function (card) {
          self.allCards[card.card.objectID] = card.card;
        });
        if (data.cards.hits) data.cards.hits.forEach(function (card) {
          self.allCards[card.card.objectID] = card.card;
        });
        __WEBPACK_IMPORTED_MODULE_4_loglevel___default.a.debug(3, self.allCards);
        self.noCardMessage = data.noCardMessage;
      }
    },
    setLoading: function setLoading() {
      this.loading = true;
      this.pingCards = [];
      this.mainCardList = [];
    },
    search: function search(optionalQuery) {
      console.log('SEARCHSEARCHSEARCH');
      var self = this;
      self.setLoading();
      if (optionalQuery && typeof optionalQuery === 'string') self.query = optionalQuery;
      self.lastQuery = self.query;
      var query = self.query;
      __WEBPACK_IMPORTED_MODULE_15__plugins_explaain_search_js__["a" /* default */].searchCards(self.auth.user, self.query, 12, true).then(function (hits) {
        __WEBPACK_IMPORTED_MODULE_9_mixpanel_browser___default.a.track('Searched', {
          organisationID: self.organisation.id,
          userID: self.auth.user.uid,
          searchQuery: query,
          noOfResults: hits.length,
          results: hits.map(function (hit) {
            return { objectID: hit.objectID, description: hit.content.description };
          })
        });
        self.loading = false;
        self.pingCards = [];
        // self.cards = hits
        self.mainCardList = hits.filter(function (card) {
          return card.fetched !== true;
        }).map(function (card) {
          return card.objectID;
        });
        self.noCardMessage = 'No cards found';
        hits.forEach(function (hit) {
          self.setCard(hit.objectID, hit);
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    searchRecent: function searchRecent() {
      var self = this;
      self.setLoading();
      __WEBPACK_IMPORTED_MODULE_4_loglevel___default.a.debug(self.auth);
      __WEBPACK_IMPORTED_MODULE_15__plugins_explaain_search_js__["a" /* default */].searchCards(self.auth.user, '', 24, false).then(function (hits) {
        __WEBPACK_IMPORTED_MODULE_9_mixpanel_browser___default.a.track('Recently Searched', {
          organisationID: self.organisation.id,
          userID: self.auth.user.uid
        });
        self.loading = false;
        console.log('hits');
        console.log(hits);
        self.pingCards = [];
        // self.cards = hits
        self.mainCardList = hits.filter(function (card) {
          return card.fetched !== true;
        }).map(function (card) {
          return card.objectID;
        });
        self.noCardMessage = 'No recent cards found';
        hits.forEach(function (hit) {
          self.setCard(hit.objectID, hit);
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    searchRandom: function searchRandom() {
      var self = this;
      self.setLoading();
      __WEBPACK_IMPORTED_MODULE_4_loglevel___default.a.debug(self.auth);
      var hits = [];
      var randomQuery = function randomQuery() {
        return Math.random().toString(36).substring(7).substring(0, 1);
      };
      var params = {
        restrictSearchableAttributes: ['title', 'content']
      };
      var promises = Array.apply(null, Array(4)).map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_15__plugins_explaain_search_js__["a" /* default */].searchCards(self.auth.user, randomQuery(), 10, false, params);
      });
      console.log(promises);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function (samplesOfHits) {
        hits = [].concat.apply([], samplesOfHits);
        hits = hits.filter(function (hit) {
          return hit.content.description.length > 10;
        });
        shuffleArray(hits);
        console.log('hits');
        console.log(hits);
        self.loading = false;
        self.pingCards = [];
        // self.cards = hits
        self.mainCardList = hits.filter(function (card) {
          return card.fetched !== true;
        }).map(function (card) {
          return card.objectID;
        });
        self.noCardMessage = 'No recent cards found';
        hits.forEach(function (hit) {
          self.setCard(hit.objectID, hit);
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    searchTempLocal: function searchTempLocal() {
      var self = this;
      var hits = [{ 'intent': 'storeMemory', 'sender': '1627888800569309', 'listItems': ['620064670', '620064680', '620064690', '620064700'], 'hasAttachments': false, 'dateUpdated': 1508426117869, 'objectID': '619948630', 'description': 'Inject Meeting Notes' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'dateUpdated': 1508426117257, 'objectID': '620064700', 'description': 'Keep all signed timesheets and receipts' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'dateUpdated': 1508426117225, 'objectID': '620064690', 'description': 'Business model => pro version only' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'dateUpdated': 1508426117152, 'objectID': '620064680', 'description': 'Languages' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'dateUpdated': 1508426116967, 'objectID': '620064670', 'description': 'Finish card creation & editing' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'dateCreated': 1508425700874, 'dateUpdated': 1508425700874, 'objectID': '651610261', 'description': 'Asdf' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'listItems': ['645331361', '610938240', '610473050'], 'hasAttachments': false, 'dateUpdated': 1508421510702, 'objectID': '639442471', 'description': 'Here is a list' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'dateUpdated': 1508421509549, 'objectID': '610938240', 'description': 'This is a brand new list' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'dateUpdated': 1508421508835, 'objectID': '645331361', 'description': 'A serious item' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'dateUpdated': 1508421508588, 'objectID': '610473050', 'description': 'Another list item' }];
      // self.cards = hits
      self.mainCardList = hits.map(function (card) {
        return card.objectID;
      });
      self.noCardMessage = 'No recent cards found';
      hits.forEach(function (hit) {
        self.setCard(hit.objectID, hit);
      });
    },
    // beginCreate: function () {
    //   this.modal.sender = this.auth.user.uid
    //   this.modal.show = true
    //   console.log(222)
    //   this.modal.submit = this.saveCard
    //   // .then(function () {
    //   //   console.log(333)
    //   // })
    //   delete this.modal.objectID
    //   this.modal.text = ''
    // },
    createCard: function createCard() {
      var card = {
        // objectID: 'TEMP_' + Math.floor(Math.random() * 10000000000),
        intent: 'storeMemory',
        content: {
          description: ''
        },
        newlyCreated: true
        // this.allCards[card.objectID] = card
      };this.popupCards = [card];
    },
    beginDelete: function beginDelete(objectID) {
      var self = this;
      self.closePopup();
      self.deleteCard(objectID).then(function () {
        self.mainCardList.forEach(function (cardID, i) {
          // temporary - doesn't check to see whether it's actually been deleted!
          if (cardID === objectID) {
            self.cards.splice(i, 1);
          }
        });
        self.pingCards.forEach(function (card, i) {
          // temporary - doesn't check to see whether it's actually been deleted!
          if (card.objectID === objectID) {
            self.pingCards.splice(i, 1);
          }
        });
      });
    },
    deleteCard: function deleteCard(objectID) {
      var self = this;
      var d = __WEBPACK_IMPORTED_MODULE_5_q___default.a.defer();
      var data = {
        sender: this.auth.user.uid,
        organisationID: self.organisation.id,
        objectID: objectID
      };
      __WEBPACK_IMPORTED_MODULE_16__plugins_explaain_author_js__["a" /* default */].deleteCard(data).then(function () {
        d.resolve();
      }).catch(function (e) {
        console.log(e);
        d.reject(e);
      });
      return d.promise;
    },
    deleteAllCards: function deleteAllCards() {
      console.log('Deleting all cards...!!!');
      var d = __WEBPACK_IMPORTED_MODULE_5_q___default.a.defer();
      var self = this;
      __WEBPACK_IMPORTED_MODULE_15__plugins_explaain_search_js__["a" /* default */].searchCards(self.auth.user, '', 1 /* 50 */, false) /* Have set this to be one at a time for now to avoid BAD THINGS */
      .then(function (hits) {
        var promises = hits.map(function (card) {
          return self.deleteCard(card.objectID);
        });
        console.log(promises);
        __WEBPACK_IMPORTED_MODULE_5_q___default.a.allSettled(promises).then(function () {
          console.log('hihihihihihi');
          d.resolve();
        }).catch(function (e) {
          d.reject(e);
        });
      }).catch(function (e) {
        console.log(e);
        d.reject(e);
      });
      return d.promise;
    },
    updateCard: function updateCard(data, callback, errorCallback) {
      var self = this;
      var promises = [];
      if (data.content && data.content.listCards && data.content.listCards.length) {
        data.content.listCards.forEach(function (listCard, index) {
          var p = __WEBPACK_IMPORTED_MODULE_5_q___default.a.defer();
          if (!listCard.objectID || listCard.objectID.indexOf('TEMP') === 0) {
            if (listCard.objectID) delete listCard.objectID;
            listCard.intent = 'storeMemory';
            listCard.sender = self.auth.user.uid;
          }
          console.log('hi');
          self.saveCard(listCard).then(function (savedListCard) {
            data.content.listItems[index] = savedListCard.objectID; // In case it was a new listCard. This also relies on the index still being correct after the asynchronous delay
            p.resolve();
          }).catch(function (e) {
            p.reject(e);
          });
          promises.push(p.promise);
        });
      }
      console.log('hello');
      __WEBPACK_IMPORTED_MODULE_5_q___default.a.allSettled(promises).then(function () {
        self.saveCard(data);
        callback();
      }).catch(function (e) {
        console.log(e);
        errorCallback(e);
      });
    },
    saveCard: function saveCard(data) {
      var d = __WEBPACK_IMPORTED_MODULE_5_q___default.a.defer();
      var self = this;
      if (data.content && data.content.listCards) delete data.content.listCards;
      if (data.newlyCreated) delete data.newlyCreated;
      if (self.getCard(data.objectID)) self.setCardProperty(data.objectID, 'updating', true);
      console.log(self.auth.user);
      // Should use self.auth.user.refreshUserToken() here!
      data.user = { uid: self.auth.user.uid, idToken: self.auth.user.getAccessToken() || self.auth.user.auth.stsTokenManager.accessToken // Ideally we should get getAccessToken() working on chrome extension so we don't need this backup option!
      };data.organisationID = self.organisation.id;
      __WEBPACK_IMPORTED_MODULE_16__plugins_explaain_author_js__["a" /* default */].saveCard(data).then(function (res) {
        var returnedCard = res.data.memories[0];
        data.objectID = returnedCard.objectID;
        data.updating = false;
        self.setCard(returnedCard.objectID, data);
        // self.setCardProperty(returnedCard.objectID, 'objectID', returnedCard.objectID) // In case it was a new data
        // self.setCardProperty(returnedCard.objectID, 'updating', false)
        d.resolve(data);
      }).catch(function (e) {
        console.error(e);
        d.reject(e);
      });
      console.log('yo1');
      return d.promise;
    },
    modalCallback: function modalCallback(message) {
      var self = this;
      this.showAlert('success', 2000, message || 'Success! Update made.');
      var query = this.lastQuery;
      setTimeout(function () {
        self.query = query;
        self.search();
      }, 1000);
    },
    copyAlert: function copyAlert() {
      this.showAlert('success', 2000, 'Copied to clipboard!');
    },
    showAlert: function showAlert(type, duration, title) {
      self.alertData = {
        show: true,
        type: type,
        title: title
      };
      setTimeout(function () {
        self.alertData.show = false;
      }, duration);
    },
    reaction: function reaction(data) {
      console.log('Reacting!');
      var self = this;
      __WEBPACK_IMPORTED_MODULE_9_mixpanel_browser___default.a.track('User Reacted to Card', {
        organisationID: self.organisation.id,
        userID: self.auth.user.uid,
        reaction: data.reaction,
        cardID: data.card.objectID,
        description: data.card.content.description,
        listItems: data.card.content.listItems,
        files: data.card.files.map(function (file) {
          return { id: file.objectID, title: file.title };
        }),
        searchQuery: self.query
      });
    }
  }

  /**
   * Randomize array element order in-place.
   * Using Durstenfeld shuffle algorithm.
   */
});function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}

/***/ }),

/***/ "jxfG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lEdC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chrome_vue__ = __webpack_require__("6a8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06475ac2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chrome_vue__ = __webpack_require__("Y4fr");
function injectStyle (ssrContext) {
  __webpack_require__("Rr7d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chrome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06475ac2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chrome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lfcg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_markdown__ = __webpack_require__("Xoog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_markdown__);
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content', 'editable'],
  components: {
    VueMarkdown: __WEBPACK_IMPORTED_MODULE_0_vue_markdown___default.a
  },
  mounted: function mounted() {
    // this.$el.innerText = this.content
  },
  watch: {
    editable: function editable(val) {
      this.$el.innerText = this.content;
    },
    content: function content(val) {
      if (!this.editable) this.$el.innerText = this.content;
    }
  },
  created: function created() {},
  methods: {
    update: function update(event) {
      this.$emit('update', event.target.innerText);
    }
  }
});

/***/ }),

/***/ "ll94":
/***/ (function(module, exports) {

module.exports = {"_args":[[{"raw":"vue-chartjs@^3.0.0","scope":null,"escapedName":"vue-chartjs","name":"vue-chartjs","rawSpec":"^3.0.0","spec":">=3.0.0 <4.0.0","type":"range"},"/Users/jeremy/savvy"]],"_from":"vue-chartjs@>=3.0.0 <4.0.0","_id":"vue-chartjs@3.0.2","_inCache":true,"_location":"/vue-chartjs","_nodeVersion":"8.8.1","_npmOperationalInternal":{"host":"s3://npm-registry-packages","tmp":"tmp/vue-chartjs-3.0.2.tgz_1510048951093_0.36970060248859227"},"_npmUser":{"name":"apertureless","email":"juszczak.j@googlemail.com"},"_npmVersion":"5.5.1","_phantomChildren":{},"_requested":{"raw":"vue-chartjs@^3.0.0","scope":null,"escapedName":"vue-chartjs","name":"vue-chartjs","rawSpec":"^3.0.0","spec":">=3.0.0 <4.0.0","type":"range"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.0.2.tgz","_shasum":"960d0ba9c2f3720b85ff02417707adc02f953de9","_shrinkwrap":null,"_spec":"vue-chartjs@^3.0.0","_where":"/Users/jeremy/savvy","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"directories":{},"dist":{"integrity":"sha512-m6ItjL8o3ff4JpbF083RzZ4KPiNBFsqMKmWCcAtlisOdm1vvB/9mUDJePmxYKJkvl2AcpvLPiH1cUrhq46r8vA==","shasum":"960d0ba9c2f3720b85ff02417707adc02f953de9","tarball":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.0.2.tgz"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"files":["src","dist","es"],"gitHead":"a5f112e952538b11739b25fafe486b56f3479f45","greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"apertureless","email":"juszczak.j@googlemail.com"}],"module":"es/index.js","name":"vue-chartjs","optionalDependencies":{},"peerDependencies":{"chart.js":"2.7.x"},"readme":"ERROR: No README data found!","repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublishOnly":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.min.js","version":"3.0.2"}

/***/ }),

/***/ "mOnf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mxtX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"alert"}},[(_vm.show)?_c('div',{staticClass:"alert",attrs:{"placement":"top","type":_vm.type,"width":"400px"}},[_c('strong',[_c('icon',{attrs:{"name":"check"}}),_vm._v(_vm._s(_vm.title))],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nhWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Welcome to Savvy!")]),_vm._v(" "),_c('h2',[_vm._v("Click on the tabs in the sidebar to get started")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nvIt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Notifications"},[_c('h1',[_vm._v("Cards Pending Your Approval")]),_vm._v(" "),_vm._l((_vm.cards),function(card){return _c('card',{key:card.objectID,attrs:{"pendingApproval":true,"data":card,"full":false}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oV5H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Help',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "olKB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__ = __webpack_require__("69NR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656c8952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__ = __webpack_require__("mxtX");
function injectStyle (ssrContext) {
  __webpack_require__("CGSI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656c8952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pTIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r+yu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ibutton_vue__ = __webpack_require__("bOqg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ad3f10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ibutton_vue__ = __webpack_require__("ydry");
function injectStyle (ssrContext) {
  __webpack_require__("Yodf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ibutton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ad3f10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ibutton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sZvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('h1',[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "srgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editable_vue__ = __webpack_require__("xAg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34cfbacb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editable_vue__ = __webpack_require__("LkkW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34cfbacb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "suNf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gdrive.e54e8c7.png";

/***/ }),

/***/ "szWv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.away),expression:"away"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_vm._v("\n            Please enter your new memory\n          ")])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.text),expression:"data.text"}],attrs:{"rows":"6","placeholder":"My secret superpower is invisibility"},domProps:{"value":(_vm.data.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data, "text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{staticClass:"modal-default-button",on:{"click":_vm.submitEvent}},[_c('icon',{attrs:{"name":"check"}}),_vm._v("\n              Done\n            ")],1)])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t1+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__ = __webpack_require__("dY5G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99142d34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__ = __webpack_require__("XMM3");
function injectStyle (ssrContext) {
  __webpack_require__("wYEC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99142d34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t8wU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardlet_vue__ = __webpack_require__("bGfq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1448dcc2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardlet_vue__ = __webpack_require__("ZvuY");
function injectStyle (ssrContext) {
  __webpack_require__("mOnf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardlet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1448dcc2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardlet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tm6V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uE8u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editable_markdown_vue__ = __webpack_require__("lfcg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c042ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editable_markdown_vue__ = __webpack_require__("1AhV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editable_markdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c042ff_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editable_markdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ujG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chrome_chrome__ = __webpack_require__("lEdC");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__webpack_require__("h2zT");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

if (document.getElementById('chrome'))
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#chrome',
    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_2__components_chrome_chrome__["a" /* default */], {
        props: {
          sidebar: false
        }
      });
    }
  });

/***/ }),

/***/ "uml9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uxU0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_chart__ = __webpack_require__("t1+F");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Analytics',
  props: ['organisation', 'auth'],
  data: function data() {
    return {
      msg: 'Welcome analytics'
    };
  },

  components: {
    chart: __WEBPACK_IMPORTED_MODULE_2__charts_chart__["a" /* default */],
    icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__["a" /* default */]
  },
  computed: {
    base: function base() {
      return {
        organisation: this.organisation
        // user: this.auth.user
      };
    }
  }
});

/***/ }),

/***/ "wTBZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wUZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("FGQs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e8b60be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("nhWu");
function injectStyle (ssrContext) {
  __webpack_require__("pTIY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e8b60be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wYEC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xAg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content', 'editable'],
  mounted: function mounted() {
    this.$el.innerText = this.content;
  },
  watch: {
    editable: function editable(val) {
      this.$el.innerText = this.content;
    },
    content: function content(val) {
      if (!this.editable) this.$el.innerText = this.content;
    }
  },
  methods: {
    update: function update(event) {
      this.$emit('update', event.target.innerText);
    }
  }
});

/***/ }),

/***/ "yNSX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('h1')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ybKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("eqfd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fadcbcd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__("szWv");
function injectStyle (ssrContext) {
  __webpack_require__("IPVE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fadcbcd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ydry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.clickEvent($event)}}},[_c('icon',{attrs:{"name":_vm.icon}}),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zLqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teams"},[_c('header',{staticClass:"teams-settings"},[_c('ibutton',{attrs:{"icon":"envelope-o","text":"Invite New User","click":_vm.toggleNewUser}}),_vm._v(" "),_c('ibutton',{attrs:{"icon":"refresh","text":"Refresh","click":_vm.getTeams}}),_vm._v(" "),(_vm.showingNewUser)?_c('form',{staticClass:"new-user"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newUser.email),expression:"newUser.email"}],staticClass:"email",attrs:{"type":"text","placeholder":"Email Address"},domProps:{"value":(_vm.newUser.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newUser, "email", $event.target.value)}}}),_vm._v(" "),_c('select',{attrs:{"name":"cars"}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Team")]),_vm._v(" "),_vm._l((_vm.teams),function(team){return _c('option',{attrs:{"value":"team.id"}},[_vm._v(_vm._s(team.name))])})],2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newUser.name.first),expression:"newUser.name.first"}],attrs:{"type":"text","placeholder":"First Name"},domProps:{"value":(_vm.newUser.name.first)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newUser.name, "first", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newUser.name.last),expression:"newUser.name.last"}],attrs:{"type":"text","placeholder":"Last Name"},domProps:{"value":(_vm.newUser.name.last)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newUser.name, "last", $event.target.value)}}}),_vm._v(" "),_c('ibutton',{attrs:{"icon":"paper-plane","text":"Invite","click":_vm.inviteNewUser}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"team"},_vm._l((_vm.teams),function(team){return _c('table',[_c('thead',[_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_vm._v(_vm._s(team.name))])])]),_vm._v(" "),_vm._l((_vm.teamUsers[team.id]),function(user){return _c('tr',{style:({ fontWeight: (user.role == 'manager' ? 'bold' : 'normal') })},[_c('td',{staticClass:"icon"},[_c('icon',{attrs:{"name":user.role === 'manager' ? 'graduation-cap' : 'user-o'}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.role.replace('member', 'Member').replace('manager', 'Team Manager')))])])})],2)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zbyJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_join_vue__ = __webpack_require__("TdAV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48dba8d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_join_vue__ = __webpack_require__("Twbz");
function injectStyle (ssrContext) {
  __webpack_require__("jxfG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_join_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48dba8d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_join_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zetg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__ = __webpack_require__("U6LC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e1e197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__ = __webpack_require__("FDVK");
function injectStyle (ssrContext) {
  __webpack_require__("OfX1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51e1e197_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["ujG6"]);


// WEBPACK FOOTER //
// static/js/chromeNewtab.316158b980146382d9ac.js